/**
 * JET Atölye Core — Fabric.js canvas + global state + event bus.
 *
 * Print area: {x:55, y:60, w:490, h:960, r:80} (canvas 600x1080)
 * Tüm panel'ler (photos, stickers, patterns, text, templates) bu canvas'a obje ekler.
 */
(function () {
  'use strict';

  if (window.JetAtolye && window.JetAtolye._initialized) return;

  var PRINT = { x: 55, y: 60, w: 490, h: 960, r: 80 };
  var CANVAS_W = 600, CANVAS_H = 1080;

  // ── Event bus ────────────────────────────────────────────
  function makeBus() {
    var listeners = {};
    return {
      on: function (ev, fn) { (listeners[ev] = listeners[ev] || []).push(fn); },
      emit: function (ev, data) { (listeners[ev] || []).forEach(function (fn) { try { fn(data); } catch (e) { console.error(e); } }); },
    };
  }
  var bus = makeBus();

  // ── State ────────────────────────────────────────────────
  var state = {
    activePanel: 'templates',
    model: null,
    modelBrand: null,
    modelSlug: null,
    modelConfirmed: false,  // ATC bunun true olmasini bekler (Faz A)
    productKey: null,             // 'tpu' | 'magsafe' (Faz 1.1)
    productHandle: null,          // variant lookup (Faz 1.1)
    productKeyConfirmed: false,   // ATC bunun da true olmasini bekler (Faz 1.1)
    _addingToCart: false,         // mutex one-in-flight (Faz 1.1)
    canvasBlocked: false,         // Faz 3.2: frame fatal sonrasi panel kullanilamaz
    _bgPreviewActive: false,      // Faz 4.5: bg preview upload mutex
    _previewDirty: false,         // Faz 4.5: canvas degisti, yeni preview gerek
    _bgPreviewTimer: null,        // Faz 4.5: debounce 2s timer ref
    lastPreviewUrl: null,         // Faz 4.5: en son uploaded preview URL (ATC reuses)
    _draftPending: false,         // 2026-09-25 B-05: "Devam et?" cevaplanana dek autoSave taslagi EZMEZ
    template: null,
    historyStack: [],
    historyIndex: -1,
    photoBlobs: {},  // jkPhotoId -> File: yüksek-res master export için orijinal pixel datası
  };

  // ── Init Fabric canvas ───────────────────────────────────
  var canvasEl = null;
  var canvas = null;

  function initCanvas() {
    canvasEl = document.getElementById('jet-canvas');
    if (!canvasEl) { console.warn('[JetAtolye] #jet-canvas not found'); return null; }
    if (typeof fabric === 'undefined') {
      console.warn('[JetAtolye] fabric not loaded');
      showFabricFail();   // D-03 (2026-09-25): eskiden yalniz console uyarisi — musteri bos atolyede kaliyordu
      return null;
    }

    // G.9 — Mobile için büyük rotation/scale handle'ları (Fabric default 13px → parmakla
    // dokunulamıyor). cornerSize görsel, touchCornerSize touch hit-area.
    fabric.Object.prototype.cornerSize = 14;
    fabric.Object.prototype.touchCornerSize = 36; // mobile finger ~30px
    fabric.Object.prototype.cornerStyle = 'circle';
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = '#1A1A1A';
    fabric.Object.prototype.cornerStrokeColor = '#FFFFFF';
    fabric.Object.prototype.borderColor = '#1A1A1A';
    fabric.Object.prototype.borderScaleFactor = 1.5;
    fabric.Object.prototype.padding = 4;

    // G.10 — Rotation handle'ı ÜSTTEN ALTA taşı + rotation icon ile belirgin yap
    if (fabric.Object.prototype.controls && fabric.Object.prototype.controls.mtr) {
      // Üstteki default rotation handle'ı gizle
      fabric.Object.prototype.controls.mtr.visible = false;

      // Alt-orta'da yeni rotation control (mbr = middle bottom rotation)
      fabric.Object.prototype.controls.mbr = new fabric.Control({
        x: 0,
        y: 0.5,
        offsetY: 36, // obje altından 36px aşağı
        cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        actionName: 'rotate',
        withConnection: true,
        cornerSize: 32,
        touchSizeX: 44,
        touchSizeY: 44,
        // Custom render: koyu daire + içinde döner ok ikonu
        render: function (ctx, left, top, _styleOverride, fabricObject) {
          var size = 28;
          ctx.save();
          ctx.translate(left, top);
          // Beyaz halo (görünürlük için)
          ctx.beginPath();
          ctx.arc(0, 0, size / 2 + 2, 0, 2 * Math.PI);
          ctx.fillStyle = '#FFFFFF';
          ctx.fill();
          // Siyah daire (ana)
          ctx.beginPath();
          ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
          ctx.fillStyle = '#1A1A1A';
          ctx.fill();
          // Rotation icon (3/4 yay + ok ucu)
          ctx.strokeStyle = '#FFFFFF';
          ctx.lineWidth = 2;
          ctx.lineCap = 'round';
          ctx.beginPath();
          ctx.arc(0, 0, 7, Math.PI * 0.15, Math.PI * 1.7);
          ctx.stroke();
          // Ok ucu (yay sonu)
          var ax = 7 * Math.cos(Math.PI * 0.15);
          var ay = 7 * Math.sin(Math.PI * 0.15);
          ctx.beginPath();
          ctx.moveTo(ax + 2.5, ay - 3);
          ctx.lineTo(ax + 4.5, ay + 1.5);
          ctx.lineTo(ax - 2, ay + 1.5);
          ctx.closePath();
          ctx.fillStyle = '#FFFFFF';
          ctx.fill();
          ctx.restore();
        }
      });
    }

    canvas = new fabric.Canvas('jet-canvas', {
      width: CANVAS_W,
      height: CANVAS_H,
      backgroundColor: 'rgba(0,0,0,0)',
      preserveObjectStacking: true,
      selection: true,
      stopContextMenu: true,
      fireRightClick: true,
      allowTouchScrolling: false,
      controlsAboveOverlay: true, // G.9 — rotation handle clipPath/overlay altında kalmasın
      imageSmoothingEnabled: true, // baskı kalitesi: high quality bicubic
    });

    // Baskı kalitesi: canvas context'lerini yüksek kaliteye çek
    // (default 'low' — bicubic yerine bilinear interpolation, yumuşak detay kaybı)
    try {
      if (canvas.contextContainer) canvas.contextContainer.imageSmoothingQuality = 'high';
      if (canvas.contextTop)       canvas.contextTop.imageSmoothingQuality = 'high';
    } catch (e) {}

    // Print area clipPath: model seçilene kadar fallback rounded-rect.
    // applyFrame(slug) çağrısında dynamic Path ile (01.alpha ∩ ~02.alpha) overrride edilir.
    canvas.clipPath = new fabric.Rect({
      left: PRINT.x,
      top: PRINT.y,
      width: PRINT.w,
      height: PRINT.h,
      rx: PRINT.r,
      ry: PRINT.r,
      absolutePositioned: true,
    });

    canvas.on('selection:created', onSelection);
    canvas.on('selection:updated', onSelection);
    canvas.on('selection:cleared', onDeselection);
    canvas.on('object:moving', updateFloatingToolbar);
    canvas.on('object:scaling', updateFloatingToolbar);
    canvas.on('object:modified', autoSave);
    canvas.on('object:added', autoSave);
    canvas.on('object:removed', autoSave);

    // M8: Print Area dışına taşıma engeli (clamp)
    // BG layer + collage slot muafiyeti — bunlar zaten kilitli ama sigorta
    canvas.on('object:moving',  function (e) { clampToPa(e.target); });
    canvas.on('object:scaling', function (e) { clampToPa(e.target); });

    // Faz 5.4 (2026-05-06): UV baski safe-zone iç guide — 3mm tolerance dashed coral kenar.
    // Default invisible; object:moving/scaling sırasında transient gösterilir, mouse:up'ta gizlenir.
    // excludeFromExport: true — print/preview export'a girmez (Faz 4.4 ile uyumlu).
    var safeZoneGuide = null;
    try {
      var inset = 18; // ~3mm UV print bleed tolerance (canvas 600×1080)
      safeZoneGuide = new fabric.Rect({
        left: PRINT.x + inset,
        top: PRINT.y + inset,
        width: PRINT.w - inset * 2,
        height: PRINT.h - inset * 2,
        rx: Math.max(0, PRINT.r - inset),
        ry: Math.max(0, PRINT.r - inset),
        fill: 'transparent',
        stroke: '#FF6B5D',
        strokeDashArray: [6, 4],
        strokeWidth: 1.5,
        strokeUniform: true,
        selectable: false,
        evented: false,
        hoverCursor: 'default',
        excludeFromExport: true,
        visible: false,
        name: '__jk_safezone_guide',
      });
      canvas.add(safeZoneGuide);
      canvas.bringToFront(safeZoneGuide);
    } catch (e) {}
    canvas.on('object:moving', function (e) {
      if (!safeZoneGuide || !e.target || e.target.name === '__jk_safezone_guide') return;
      if (!safeZoneGuide.visible) {
        safeZoneGuide.set('visible', true);
        canvas.bringToFront(safeZoneGuide);
        canvas.requestRenderAll();
      }
    });
    canvas.on('object:scaling', function (e) {
      if (!safeZoneGuide || !e.target || e.target.name === '__jk_safezone_guide') return;
      if (!safeZoneGuide.visible) {
        safeZoneGuide.set('visible', true);
        canvas.bringToFront(safeZoneGuide);
        canvas.requestRenderAll();
      }
    });
    canvas.on('mouse:up', function () {
      if (safeZoneGuide && safeZoneGuide.visible) {
        safeZoneGuide.set('visible', false);
        canvas.requestRenderAll();
      }
    });

    // S27v16 (2026-05-22): Kenar handle (ml/mr/mt/mb) kose gibi davransin -> uniform scale.
    // Yusuf isteği: "kenar handlelari dursun ama onlar da koselerin islevini gorsun" (foto stretching engel).
    canvas.on('object:scaling', function (e) {
      var o = e && e.target;
      var corner = e && e.transform && e.transform.corner;
      if (!o || !corner) return;
      if (corner === 'ml' || corner === 'mr') {
        o.scaleY = o.scaleX;
      } else if (corner === 'mt' || corner === 'mb') {
        o.scaleX = o.scaleY;
      }
    });

    // G.1 (v2.2 kaldırıldı): turuncu print-area grid SVG kaldırıldı, toggleOverlayGrid no-op.

    // G.6 — Undo snapshot'ları
    canvas.on('object:added', pushUndoSnapshot);
    canvas.on('object:modified', pushUndoSnapshot);

    // v2.8.3: Yeni eklenen her objeye canvas.clipPath klonu ata (text fix).
    canvas.on('object:added', function (e) { assignObjectClipPath(e.target); });
    canvas.on('object:removed', pushUndoSnapshot);

    // G.7 — Yeni eklenen obje default LOCKED (focus-to-edit pattern)
    canvas.on('object:added', function (e) {
      var o = e && e.target;
      if (isLockable(o) && !o.jkPermanentLock) {
        // Aktif obje değilse sabit (selection eventi unlock edecek)
        if (canvas.getActiveObject() !== o) {
          o.lockMovementX = true;
          o.lockMovementY = true;
        }
      }
    });

    return canvas;
  }

  // Faz J-6 (2026-05-07): canvas.clipPath bbox dinamik — kılıfın gerçek silüetini takip eder.
  // J-4'te PRINT sabit yapmıştık ama kılıfın iç alanı silüetten KISITLAYICI olduğu için
  // foto'nun kenarları kılıf çizgisinin DIŞINA değil İÇİNE düşüyordu — kullanıcı bunu "taşma"
  // sanıyordu. Doğru çözüm: PA = canvas.clipPath bbox (silüetin tam içi) + canvas.clipPath
  // (path) ile silüet dışı maskeleme. Cover scale foto'yu bbox'a doldurur, kılıf dışına
  // çıkamaz (canvas-level mask). Mockup overlay'in bezel/kamera kısmı opaque PNG olduğu için
  // foto kameranın altında otomatik gizlenir.
  function getPrintBounds() {
    if (canvas && canvas.clipPath) {
      try {
        var bbox = canvas.clipPath.getBoundingRect(true, true);
        if (bbox && bbox.width > 0 && bbox.height > 0) {
          return { x: bbox.left, y: bbox.top, w: bbox.width, h: bbox.height, r: PRINT.r,
                   cx: bbox.left + bbox.width / 2, cy: bbox.top + bbox.height / 2 };
        }
      } catch (e) {}
    }
    return { x: PRINT.x, y: PRINT.y, w: PRINT.w, h: PRINT.h, r: PRINT.r,
             cx: PRINT.x + PRINT.w / 2, cy: PRINT.y + PRINT.h / 2 };
  }

  // M8 + drag-fix: Obje hareketinde / scaling'de Canvas kuralları
  // v2.8: Tum konum-engelleyici clamp KALDIRILDI (kullanici talebi: madde 6).
  // Kullanici fotoğraf/yazı/sticker'ı istediği kadar taşıyabilir, canvas dışına
  // bile çıkabilir. Fabric.js içinde Group veya Rect drag'i sınırsızdır.
  // ClipPath (canvas-level, telefon silüeti) sayesinde frame dışı görsel olarak
  // KESİLİR — yani objeyi sürüklerken sadece frame içindeki kısmı görünür.
  // Bu sayede madde 7 de otomatik karşılanır (frame dışında hiçbir şey görünmez).
  function clampToPa(_o) { /* no-op */ }

  // G.1 (v2.2 kaldırıldı): turuncu print-area grid SVG kaldırıldı.
  // toggleOverlayGrid fonksiyonu kaldırıldı; event listener'ları da kaldırıldı (initCanvas).

  // G.6 + M9 — Undo + Redo (state snapshot stack, max 25)
  var undoStack = [];
  var redoStack = [];   // M9: redo branch
  var UNDO_MAX = 25;
  var undoMuted = false; // undo/redo sırasında snapshot push'u mute et

  // 2026-09-25 (B-03 devami): model kesimi (canvas + nesne clipPath'leri) kayda girmez — her geri yuklemede
  // reapplyCurrentClip secili modelinkini uygular. Aksi halde nesneye kesim object:added'dan SONRA atandigi icin
  // gorunmez bir fark "bos" Geri al adimi uretiyordu; uzun path string'leri de her kayitta tekrarlaniyordu.
  // Arka plan katmani ve kolaj slotlarinin kendi kesimleri korunur (reapply bunlara dokunmaz).
  function _stripModelClips(json) {
    if (!json) return json;
    delete json.clipPath;
    (json.objects || []).forEach(function (o) {
      // Sablon v2 (2026-10-03): yuvadaki fotonun kesimi yuva seklidir (model kesimi degil) -> korunur
      if (o && o.name !== '__jk_bg_layer' && !o.isCollageSlot && o.jkSlotIndex == null) delete o.clipPath;
    });
    return json;
  }
  // Sablon v2: yuva/sablon alanlari Geri al, taslak ve imza kayitlarina girer (yoksa yuva bilgisi kaybolur)
  var JK_JSON_PROPS = ['name', 'kind', 'jkPhotoId', 'isCollageSlot', 'slotEmpty', 'slotIndex', 'slotShape', 'slotIsInner',
    'jkSlotIndex', 'jkTplSlot', 'jkSlotGeom', 'jkTplText', 'jkTplMaxW', 'jkTplMaxChars'];

  // C10/B-14 (2026-09-30): her kayit (25'e kadar) her fotografin tam base64'unu tekrar tutuyordu (5 foto x 25 kayit
  // = yuzlerce MB, mobilde sekme cokmesi). Buyuk src'ler bellekte TEK kopya havuzda tutulur, kayitta 'jkpool:<anahtar>'.
  // Havuz senkron (IndexedDB'ye bagli degil -> ozel modda da ayni davranis). Kayitlarda gecmeyen anahtarlar silinir.
  var _undoPool = {};
  function _poolKey(o, src) {
    var n = src.length, mid = Math.floor(n / 2);
    return (o.jkPhotoId || 'x') + '|' + n + '|' + src.slice(-160) + '|' + src.substr(mid, 160);
  }
  function _poolStrip(objs) {
    (objs || []).forEach(function (o) {
      if (!o) return;
      if (typeof o.src === 'string' && o.src.length > 1024) {
        var k = _poolKey(o, o.src);
        _undoPool[k] = o.src;
        o.src = 'jkpool:' + k;
      }
      if (o.objects) _poolStrip(o.objects);
    });
  }
  function _poolHydrate(jsonStr) {
    var j = JSON.parse(jsonStr);
    (function walk(objs) {
      (objs || []).forEach(function (o) {
        if (!o) return;
        if (typeof o.src === 'string' && o.src.indexOf('jkpool:') === 0) o.src = _undoPool[o.src.slice(7)] || '';
        if (o.objects) walk(o.objects);
      });
    })(j.objects);
    return j;
  }
  function _poolPrune() {
    var used = {};
    undoStack.concat(redoStack).forEach(function (str) {
      var re = /"src":"jkpool:([^"]*)"/g, m; // anahtar: foto id + uzunluk + base64 parcasi (tirnak/ters bolu icermez)
      while ((m = re.exec(str))) used[m[1]] = true;
    });
    Object.keys(_undoPool).forEach(function (k) { if (!used[k]) delete _undoPool[k]; });
  }
  function pushUndoSnapshot() {
    if (!canvas || undoMuted) return;
    try {
      var snap = _stripModelClips(canvas.toJSON(JK_JSON_PROPS));
      _poolStrip(snap.objects);
      var json = JSON.stringify(snap);
      // Aynı state'i tekrar push'lama
      if (undoStack.length > 0 && undoStack[undoStack.length - 1] === json) return;
      undoStack.push(json);
      if (undoStack.length > UNDO_MAX) undoStack.shift();
      // M9: Yeni işlem → redo dalı kesilir (branching)
      redoStack.length = 0;
      _poolPrune();
      updateUndoRedoBtnState();
    } catch (e) {
      console.warn('[undo] snapshot fail', e);
    }
  }

  // Sablon v2: cok nesneli islem (sablon kurulumu) TEK Geri al adimi olsun — ara durumlar kayda girmez.
  function undoBatch(fn) {
    var was = undoMuted;
    undoMuted = true;
    try { fn(); } finally { undoMuted = was; }
    if (!was) { pushUndoSnapshot(); autoSave(); }
  }

  // Sablon v2: bos foto yuvasi yer tutuculari (kesikli cerceve + "Fotoğraf ekle") baski/onizleme ciktisina girmez.
  function _hideTplSlots() {
    var hid = canvas ? canvas.getObjects().filter(function (o) { return o && o.jkTplSlot && o.isCollageSlot && o.visible; }) : [];
    hid.forEach(function (o) { o.visible = false; });
    return function () { hid.forEach(function (o) { o.visible = true; }); };
  }

  function performUndo() {
    if (undoStack.length < 2 || !canvas) return; // mevcut + en az 1 önceki
    var current = undoStack.pop(); // mevcut state'i çıkar
    redoStack.push(current);       // M9: redo'ya at
    if (redoStack.length > UNDO_MAX) redoStack.shift();
    var prev = undoStack[undoStack.length - 1];
    if (!prev) return;
    undoMuted = true;
    canvas.loadFromJSON(_poolHydrate(prev), function () {
      reapplyCurrentClip();   // B-03: kayittaki (eski modelin) kesimi degil, secili modelinki
      canvas.requestRenderAll();
      undoMuted = false;
      updateUndoRedoBtnState();
      autoSave();
    });
  }

  // M9: Redo — redoStack'tan al, undoStack'e push, canvas'a yükle
  function performRedo() {
    if (redoStack.length === 0 || !canvas) return;
    var next = redoStack.pop();
    undoStack.push(next);
    if (undoStack.length > UNDO_MAX) undoStack.shift();
    undoMuted = true;
    canvas.loadFromJSON(_poolHydrate(next), function () {
      reapplyCurrentClip();   // B-03
      canvas.requestRenderAll();
      undoMuted = false;
      updateUndoRedoBtnState();
      autoSave();
    });
  }

  function updateUndoRedoBtnState() {
    var ub = document.getElementById('jw-undo-btn');
    if (ub) ub.disabled = undoStack.length < 2;
    var rb = document.getElementById('jw-redo-btn');
    if (rb) rb.disabled = redoStack.length === 0;
  }
  // Geriye uyumluluk
  var updateUndoBtnState = updateUndoRedoBtnState;

  function initUndoButton() {
    // Undo btn
    if (!document.getElementById('jw-undo-btn')) {
      var btn = document.createElement('button');
      btn.id = 'jw-undo-btn';
      btn.type = 'button';
      btn.className = 'jw__undo-btn';
      btn.setAttribute('aria-label', 'Geri al');
      btn.title = 'Geri al (Ctrl+Z)';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 0 0-4-4H4"/></svg>';
      btn.disabled = true;
      btn.addEventListener('click', performUndo);
      document.body.appendChild(btn);
    }
    // M9: Redo btn (undo'nun yanına)
    if (!document.getElementById('jw-redo-btn')) {
      var rbtn = document.createElement('button');
      rbtn.id = 'jw-redo-btn';
      rbtn.type = 'button';
      rbtn.className = 'jw__redo-btn';
      rbtn.setAttribute('aria-label', 'İleri al');
      rbtn.title = 'İleri al (Ctrl+Y / Ctrl+Shift+Z)';
      rbtn.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 14 20 9 15 4"/><path d="M4 20v-7a4 4 0 0 1 4-4h12"/></svg>';
      rbtn.disabled = true;
      rbtn.addEventListener('click', performRedo);
      document.body.appendChild(rbtn);
    }

    // Keyboard Ctrl+Z (undo) / Ctrl+Y veya Ctrl+Shift+Z (redo)
    document.addEventListener('keydown', function (e) {
      if (isInputFocused()) return;
      var meta = e.ctrlKey || e.metaKey;
      if (!meta) return;
      if (e.key === 'z' && !e.shiftKey) {
        e.preventDefault();
        performUndo();
      } else if (e.key === 'y' || (e.key === 'z' && e.shiftKey) || (e.key === 'Z' && e.shiftKey)) {
        e.preventDefault();
        performRedo();
      }
    });
  }

  // G.4 v3 (2026-10-03) — Iki parmak: pinch-zoom + dondurme (mobile-only, Hammer.js)
  // v2'den devralinan: dinleyici #jw-stage, hedef ilk dokunusta yakalanir, ilk parmak kaymasi geri alinir,
  // iOS gesturestart engellenir, bitiste object:modified (undo/autosave/preview zinciri).
  // v3 eki: Rotate recognizer (Pinch ile recognizeWith). Aci Hammer'in e.rotation'indan ALINMAZ:
  // Hammer 2.0.8 getRotation() fark degil TOPLAM donduruyor (start acisi + simdiki aci) -> jest basinda
  // 2x(parmak egimi) sicrama + ±180 sarma. Aci parmak vektorunden kare-kare hesaplanir.
  // Gurultu bastirma: olu bolge 12°, parmaklar 48px'ten yakinken aci guncellenmez, yumusatma, 0/90/180/270'e ±5° yapisma.
  function initGestures() {
    if (!canvas) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return; // mobile-only
    if (typeof Hammer === 'undefined') {
      setTimeout(initGestures, 200);
      return;
    }
    var gestureEl = document.getElementById('jw-stage') || canvas.upperCanvasEl || canvas.lowerCanvasEl;
    if (!gestureEl || gestureEl.__jkHammer) return;
    gestureEl.__jkHammer = true;
    try { gestureEl.addEventListener('gesturestart', function (ev) { ev.preventDefault(); }, { passive: false }); } catch (e) {}

    var ROT_DEAD = 12;     // derece: bu esik asilmadan donme yok (sikistirma gurultusu)
    var ROT_SNAP = 5;      // derece: 0/90/180/270'e yapisma
    var ROT_MIN_DIST = 48; // px: parmaklar bundan yakinken aci olcumu guvenilmez -> guncelleme yok
    var ROT_SMOOTH = 0.35; // 0..1 ustel yumusatma (her karede hedefe yaklasma orani)
    var SCALE_DEAD = 0.05; // Pinch threshold ile ayni

    var hammer = new Hammer.Manager(gestureEl, {
      touchAction: 'none',
      recognizers: [
        [Hammer.Pinch, { enable: true, threshold: SCALE_DEAD }],
        [Hammer.Rotate, { enable: true, threshold: 0 }]
      ]
    });
    hammer.get('pinch').recognizeWith(hammer.get('rotate'));

    var startScale = 1, startLeft = 0, startTop = 0, startAngle = 0, startCenter = null;
    var gesturing = false, target = null;
    var savedSelection = true;
    var lastActive = null, downActive = null, downLeft = 0, downTop = 0;
    var lastSrc = null, prevVecAngle = null, rotAccum = 0, rotLatched = false, scaleLatched = false;
    var appliedAngle = 0, targetAngle = 0, curScale = 1, rotAllowed = true;

    function pinchable(obj) {
      if (!obj || obj.type === 'activeSelection') return false;
      if (obj.name === '__jk_bg_layer' || obj.isCollageSlot) return false;
      if (obj.jkPermanentLock || obj.lockScalingX || obj.lockScalingY) return false;
      return canvas.getObjects().indexOf(obj) >= 0;
    }
    canvas.on('selection:created', function () { lastActive = canvas.getActiveObject(); });
    canvas.on('selection:updated', function () { lastActive = canvas.getActiveObject(); });

    gestureEl.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'touch' || !ev.isPrimary) return;
      downActive = canvas.getActiveObject() || null;
      if (downActive) { downLeft = downActive.left; downTop = downActive.top; }
    }, true);

    function normDeg(a) { a = a % 360; if (a > 180) a -= 360; if (a <= -180) a += 360; return a; }
    function snapDeg(a) {
      var n = ((a % 360) + 360) % 360;
      var m = Math.round(n / 90) * 90;
      return Math.abs(n - m) <= ROT_SNAP ? (a - n + m) : a;
    }
    // Iki parmak vektoru: pointer id'ye gore sirali (Hammer pointers sirasina guvenme)
    function fingerVec(e) {
      var p = e.pointers;
      if (!p || p.length < 2) return null;
      var a = p[0], b = p[1];
      var ia = a.pointerId !== undefined ? a.pointerId : a.identifier;
      var ib = b.pointerId !== undefined ? b.pointerId : b.identifier;
      if (ib < ia) { var t = a; a = b; b = t; }
      var dx = b.clientX - a.clientX, dy = b.clientY - a.clientY;
      return { ang: Math.atan2(dy, dx) * 180 / Math.PI, dist: Math.sqrt(dx * dx + dy * dy) };
    }

    function beginGesture(e) {
      if (gesturing) return;
      var obj = canvas.getActiveObject();
      if (!pinchable(obj)) obj = pinchable(downActive) ? downActive : (pinchable(lastActive) ? lastActive : null);
      if (!obj) return;
      if (obj === downActive) obj.set({ left: downLeft, top: downTop }); // ilk parmak surukleme kaymasini geri al
      if (canvas.getActiveObject() !== obj) canvas.setActiveObject(obj);
      target = obj;
      gesturing = true;
      startScale = obj.scaleX || 1;
      startLeft = obj.left;
      startTop = obj.top;
      startAngle = obj.angle || 0;
      obj.setCoords();
      startCenter = obj.getCenterPoint();
      rotAllowed = !obj.lockRotation;
      var v = fingerVec(e);
      prevVecAngle = v ? v.ang : null;
      rotAccum = 0; rotLatched = false; scaleLatched = false;
      appliedAngle = targetAngle = startAngle; curScale = startScale;
      lastSrc = null;
      savedSelection = canvas.selection;
      canvas.selection = false;
      obj.lockMovementX = true;
      obj.lockMovementY = true;
      onMove(e); // baslangic karesini de uygula (v2'de 'pinch' handler'i start'ta da calisiyordu)
    }

    function applyTransform(obj) {
      obj.set({ scaleX: curScale, scaleY: curScale });
      if (rotLatched) {
        obj.set('angle', appliedAngle);
        obj.setPositionByOrigin(startCenter, 'center', 'center'); // merkez etrafinda don
      } else {
        obj.set({ left: startLeft, top: startTop }); // v2 davranisi (yalniz olcek)
      }
      obj.setCoords();
    }

    function onMove(e) {
      if (!gesturing || !target) return;
      if (e.srcEvent && e.srcEvent === lastSrc) return; // pinch + rotate ayni girdiyi iki kez yollar
      lastSrc = e.srcEvent;
      var obj = target;
      // Olcek (v2 ile ayni formul; yalniz rotate tetiklediyse de SCALE_DEAD sonrasi)
      if (!scaleLatched && Math.abs((e.scale || 1) - 1) >= SCALE_DEAD) scaleLatched = true;
      if (scaleLatched) curScale = startScale * Math.max(0.1, Math.min(5, e.scale || 1));
      // Aci: kare-kare fark, normalize, kisa mesafede dondur
      var v = fingerVec(e);
      if (v && rotAllowed) {
        if (prevVecAngle !== null && v.dist >= ROT_MIN_DIST) rotAccum += normDeg(v.ang - prevVecAngle);
        prevVecAngle = v.ang;
        if (!rotLatched && Math.abs(rotAccum) >= ROT_DEAD) rotLatched = true;
        if (rotLatched) {
          targetAngle = snapDeg(startAngle + rotAccum);
          appliedAngle += (targetAngle - appliedAngle) * ROT_SMOOTH;
        }
      }
      applyTransform(obj);
      canvas.requestRenderAll();
      updateFloatingToolbar();
    }

    function endGesture() {
      if (!gesturing) return;
      var obj = target;
      if (obj) {
        if (rotLatched) appliedAngle = targetAngle; // yumusatma gecikmesini kapat, yapismis son aci
        applyTransform(obj);
        if (rotLatched) obj.set('angle', ((obj.angle % 360) + 360) % 360);
        var keepLocked = !!obj.jkPermanentLock;
        obj.lockMovementX = keepLocked;
        obj.lockMovementY = keepLocked;
        obj.setCoords();
        if (scaleLatched || rotLatched) canvas.fire('object:modified', { target: obj }); // undo/autosave zinciri
        canvas.requestRenderAll();
      }
      canvas.selection = savedSelection;
      gesturing = false;
      target = null;
      autoSave();
    }

    hammer.on('pinchstart rotatestart', beginGesture);
    hammer.on('pinchmove rotatemove', onMove);
    hammer.on('pinchend rotateend pinchcancel rotatecancel', endGesture);
  }

  // G.2 — Keyboard delete (Delete/Backspace). Input'ta ise skip.
  function isInputFocused() {
    var el = document.activeElement;
    if (!el) return false;
    var tag = (el.tagName || '').toLowerCase();
    return tag === 'input' || tag === 'textarea' || tag === 'select' || el.isContentEditable;
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Delete' && e.key !== 'Backspace') return;
    if (isInputFocused()) return;
    if (!canvas) return;
    var obj = canvas.getActiveObject();
    if (!obj) return;
    // BG layer tek başına seçili ise skip
    if (obj.type !== 'activeSelection' && obj.name === '__jk_bg_layer') return;
    e.preventDefault();
    removeActiveOrSelection(); // multi-select destekli
  });

  // ── Active object floating toolbar ───────────────────────
  function ensureToolbarOnBody() {
    // G.2 — Fixed pozisyonu garanti için toolbar'ı body'a taşı (parent transform sorunu)
    var tb = document.getElementById('ja-floating-toolbar');
    if (tb && tb.parentElement !== document.body) {
      document.body.appendChild(tb);
    }
  }
  function onSelection(e) {
    ensureToolbarOnBody();
    var tb = document.getElementById('ja-floating-toolbar');
    if (!tb) return;
    tb.hidden = false;
    syncToolbarVisibility();
    syncLockBtnState();
    updateFloatingToolbar();
    var hint = document.getElementById('ja-canvas-hint');
    if (hint) hint.classList.add('hidden');
    // G.7 — Otomatik focus-to-edit: aktif obje serbest, deselected obje sabit
    autoLockFocusToEdit(e);
  }
  function onDeselection(e) {
    var tb = document.getElementById('ja-floating-toolbar');
    if (tb) tb.hidden = true;
    // G.7 — Deselect olan obje(leri) sabitle (jkPermanentLock korunur)
    autoLockFocusToEdit(e);
  }

  // G.7 — Otomatik focus-to-edit logic
  function isLockable(o) {
    return o && o.name !== '__jk_bg_layer' && !o.isCollageSlot;
  }
  function applyAutoLock(obj, lock) {
    if (!isLockable(obj)) return;
    // Permanent kilit override
    if (obj.jkPermanentLock) {
      obj.lockMovementX = true;
      obj.lockMovementY = true;
      return;
    }
    obj.lockMovementX = lock;
    obj.lockMovementY = lock;
  }
  function autoLockFocusToEdit(evt) {
    if (!canvas) return;
    // Yeni aktif obje(leri)i unlock
    var active = canvas.getActiveObject();
    if (active) applyAutoLock(active, false);
    // Deselected obje(leri)i lock (event objesinden gelir)
    if (evt && evt.deselected && evt.deselected.length) {
      evt.deselected.forEach(function (o) { applyAutoLock(o, true); });
    }
    // Selection cleared (e.deselected boş ise tüm objeler için pasif lock)
    if (!active && (!evt || !evt.deselected)) {
      canvas.getObjects().forEach(function (o) { applyAutoLock(o, true); });
    }
  }
  function updateFloatingToolbar() {
    var obj = canvas && canvas.getActiveObject();
    if (!obj) return;
    var tb = document.getElementById('ja-floating-toolbar');
    if (!tb) return;
    var canvasEl = canvas.upperCanvasEl || canvas.lowerCanvasEl;
    if (!canvasEl) return;
    var canvasRect = canvasEl.getBoundingClientRect();
    var tbW = tb.offsetWidth || 240;
    var tbH = tb.offsetHeight || 50;

    // S27v25 (2026-05-31) restore: S27v7+v9-10+v13 — toolbar mockup'in ust dis kenarinda SABIT durur.
    // Obje hareketinden bagimsiz. Ust yer yoksa mockup ICINE girme (kamerali kismi kapatir),
    // mockup'in ALTINA yapis. Hicbir taraf sigamiyorsa viewport top'a clamp.
    var centerX = canvasRect.left + canvasRect.width / 2;
    var leftEdge = centerX - tbW / 2;
    leftEdge = Math.max(8, Math.min(window.innerWidth - tbW - 8, leftEdge));

    // B-10 (2026-09-25): ust sinir 8 px idi -> mobilde cubuk ust menunun (ja-shell, z-index 105) ALTINDA kaliyor,
    // 9/9 dugme tiklanamiyordu. Ust sinir artik menunun alt kenari.
    var topLimit = 8;
    try {
      var shellEl = document.querySelector('.ja-shell');
      if (shellEl) topLimit = Math.max(8, Math.round(shellEl.getBoundingClientRect().bottom) + 4);
    } catch (e) {}
    var y = canvasRect.top - tbH;
    if (y < topLimit) {
      var yBottom = canvasRect.bottom + 8;
      if (yBottom + tbH <= window.innerHeight - 8) y = yBottom;
      else y = topLimit;
    }

    // C1/B-10 (2026-09-30): alt sinir = mobil alt cubugun (.jw__bottombar) ust kenari; cubuk alt menunun altina girmesin.
    var bb = document.querySelector('.jw__bottombar');
    var bbR = bb ? bb.getBoundingClientRect() : null; // fixed eleman: offsetParent hep null, rect ile bak
    var bottomLimit = (bbR && bbR.height > 0 && bbR.top < window.innerHeight) ? bbR.top - 8 : window.innerHeight - 8;
    y = Math.max(topLimit, Math.min(y, bottomLimit - tbH));

    tb.style.left = leftEdge + 'px';
    tb.style.top = y + 'px';
    tb.style.transform = 'none';
    tb.style.position = 'fixed';
  }

  // 2026-04-29 — Outside-click auto-close: canvas + toolbar dışına tıklayınca selection clear
  document.addEventListener('mousedown', function (e) {
    if (!canvas) return;
    var tb = document.getElementById('ja-floating-toolbar');
    var canvasEl = canvas.upperCanvasEl;
    if (!canvasEl) return;
    var clickedToolbar = tb && tb.contains(e.target);
    var clickedCanvas = canvasEl.contains(e.target);
    var clickedDevice = e.target && e.target.closest && e.target.closest('.jw__device, .ja-canvas-device');
    var clickedSheet = e.target && e.target.closest && e.target.closest('.jw__sheet, .jw__panel, .jw__bottombar, #jw-saved-modal, #jw-shortcuts-modal, [class*="modal"]');
    if (clickedToolbar || clickedCanvas || clickedDevice || clickedSheet) return;
    // Dışa tıklama → selection clear
    if (canvas.getActiveObject()) {
      canvas.discardActiveObject();
      canvas.requestRenderAll();
    }
  }, true);

  // ── Floating toolbar action handlers ─────────────────────
  function setupFloatingToolbar() {
    var tb = document.getElementById('ja-floating-toolbar');
    if (!tb) return;
    tb.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-action]');
      if (!btn) return;
      var act = btn.dataset.action;
      var obj = canvas.getActiveObject();
      if (!obj) return;

      if (act === 'rotateLeft')  obj.rotate(((obj.angle || 0) - 90) % 360);
      else if (act === 'rotateRight') obj.rotate(((obj.angle || 0) + 90) % 360);
      else if (act === 'flipH')   obj.set('flipX', !obj.flipX);
      else if (act === 'flipV') {
        if (window.JetCanvasEdit) window.JetCanvasEdit.flipV(obj);
        else obj.set('flipY', !obj.flipY);
      }
      else if (act === 'crop') {
        if (obj.type !== 'image') {
          notify('Kirpma yalnizca foto/sticker icin', 'warning');
        } else if (window.JetCanvasEdit) {
          window.JetCanvasEdit.startCrop(obj);
        }
      }
      else if (act === 'zoomFit') {
        if (window.JetCanvasEdit) window.JetCanvasEdit.zoomFit(obj);
      }
      else if (act === 'fitToCase') {
        // M10: Aktif obje PA'ya cover scale + center (v2.2: dinamik clipPath bbox)
        if (obj.name === '__jk_bg_layer' || obj.isCollageSlot) {
          notify('Bu obje için Kılıfa Oturt geçerli değil', 'warning');
        } else if (window.JetCanvasEdit && window.JetCanvasEdit.fitToCase) {
          window.JetCanvasEdit.fitToCase(obj, getPrintBounds());
        } else {
          // Fallback inline cover (dinamik bbox)
          var P = getPrintBounds();
          var sx = P.w / (obj.width || 1);
          var sy = P.h / (obj.height || 1);
          var s = Math.max(sx, sy); // cover
          obj.set({
            scaleX: s, scaleY: s,
            left: P.cx,
            top: P.cy,
            originX: 'center', originY: 'center',
            angle: 0,
          });
          obj.setCoords();
          canvas.requestRenderAll();
        }
      }
      else if (act === 'duplicate') {
        obj.clone(function (clone) {
          clone.set({ left: (clone.left || 0) + 30, top: (clone.top || 0) + 30 });
          if (clone.type === 'activeSelection') {
            // C14/B-15 (2026-09-30): coklu secimde ActiveSelection kanvasa tek nesne olarak ekleniyordu (bozuk grup)
            canvas.discardActiveObject();
            clone.canvas = canvas;
            clone.forEachObject(function (o) { canvas.add(o); });
            clone.setCoords();
          } else canvas.add(clone);
          canvas.setActiveObject(clone);
          canvas.requestRenderAll();
        });
      } else if (act === 'bringForward') canvas.bringForward(obj);
      else if (act === 'sendBackward') {
        canvas.sendBackwards(obj);
        // C14/B-15: arka plan katmaninin arkasina gecip gorunmez olmasin
        var bgL = canvas.getObjects().filter(function (o) { return o.name === '__jk_bg_layer'; }).pop();
        (obj.type === 'activeSelection' ? obj.getObjects() : [obj]).forEach(function (o) {
          var oi = canvas.getObjects().indexOf(o), bi = bgL ? canvas.getObjects().indexOf(bgL) : -1;
          if (oi >= 0 && oi < bi) canvas.moveTo(o, bi);
        });
      }
      else if (act === 'toggleLock') {
        // G.7 Hibrit — kalıcı kilit (auto focus-to-edit'i override eder)
        var nowLocked = !obj.jkPermanentLock;
        obj.jkPermanentLock = nowLocked;
        obj.lockMovementX = nowLocked;
        obj.lockMovementY = nowLocked;
        obj.lockScalingX = nowLocked;
        obj.lockScalingY = nowLocked;
        obj.lockRotation = nowLocked;
        obj.hasControls = !nowLocked;
        if (typeof obj.setControlsVisibility === 'function') {
          obj.setControlsVisibility({
            tl: !nowLocked, tr: !nowLocked, bl: !nowLocked, br: !nowLocked,
            ml: !nowLocked, mt: !nowLocked, mr: !nowLocked, mb: !nowLocked,
            mbr: !nowLocked, mtr: false
          });
        }
        syncLockBtnState();
        // 2026-04-29 — Kilit aktivasyonundan sonra selection clear (panel/toolbar otomatik kapansın)
        if (nowLocked) {
          setTimeout(function () {
            canvas.discardActiveObject();
            canvas.requestRenderAll();
          }, 220); // kullanıcı kilit ikonunu görsel olarak görmek için kısa delay
        }
      }
      else if (act === 'delete') {
        removeActiveOrSelection(); // toplu seçim destekli
      }
      canvas.requestRenderAll();
      updateFloatingToolbar();
    });
  }

  // G.8 — Aktif obje VEYA ActiveSelection (multi) silme
  function removeActiveOrSelection() {
    if (!canvas) return;
    var obj = canvas.getActiveObject();
    if (!obj) return;
    if (obj.type === 'activeSelection') {
      // Multi-select — içindeki her objeyi sil (BG layer hariç)
      obj.getObjects().slice().forEach(function (o) {
        if (o && o.name !== '__jk_bg_layer') canvas.remove(o);
      });
      canvas.discardActiveObject();
    } else if (obj.name !== '__jk_bg_layer') {
      canvas.remove(obj);
      canvas.discardActiveObject();
    }
    canvas.requestRenderAll();
  }

  // G.7 — Toolbar lock buton görsel state senkronizasyonu
  function syncLockBtnState() {
    var tb = document.getElementById('ja-floating-toolbar');
    if (!tb) return;
    var btn = tb.querySelector('button[data-action="toggleLock"]');
    if (!btn) return;
    var obj = canvas && canvas.getActiveObject();
    var locked = !!(obj && obj.jkPermanentLock);
    btn.classList.toggle('is-locked', locked);
    btn.title = locked ? 'Sabitlemeyi kaldır' : 'Sabitle';
  }

  // Selection degisiminde image-only butonlari toggle (crop, flipV)
  function syncToolbarVisibility() {
    var tb = document.getElementById('ja-floating-toolbar');
    if (!tb) return;
    var obj = canvas && canvas.getActiveObject();
    var isImage = obj && obj.type === 'image';
    tb.querySelectorAll('button[data-image-only="true"]').forEach(function (b) {
      b.style.display = isImage ? '' : 'none';
    });
  }

  // ── 2026-09-25 B-05: taslak fotograflari IndexedDB'de ─────────────────────
  // localStorage 5 MB oldugu icin foto src'leri taslaktan budaniyordu; "Kaydet" "sayfayi kapatsan bile
  // geri acabilirsin" diyordu ama yenilemede foto bos (gorunmez) nesne olarak geliyordu.
  // Artik foto verisi IndexedDB'de (anahtar = jkPhotoId); localStorage taslaginda src bos kalir,
  // geri yuklemede buradan doldurulur. Bulunamayan foto sessizce gorunmez nesne olmaz, uyari verilir.
  var IDB_NAME = 'jetkilif-atolye', IDB_STORE = 'taslak-foto';
  var _idbOpenP = null;
  var _idbSaved = {};      // jkPhotoId -> yazilan src uzunlugu ('p'+uzunluk = yaziliyor)
  var _idbWarned = false;
  function _idbOpen() {
    if (!_idbOpenP) {
      _idbOpenP = new Promise(function (resolve, reject) {
        try {
          if (!window.indexedDB) { reject(new Error('indexedDB yok')); return; }
          var rq = window.indexedDB.open(IDB_NAME, 1);
          rq.onupgradeneeded = function () { try { rq.result.createObjectStore(IDB_STORE); } catch (e) {} };
          rq.onsuccess = function () { resolve(rq.result); };
          rq.onerror = function () { reject(rq.error || new Error('idb open')); };
          rq.onblocked = function () { reject(new Error('idb blocked')); };
        } catch (e) { reject(e); }
      });
    }
    return _idbOpenP;
  }
  function _idbTx(mode, fn) {
    return _idbOpen().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(IDB_STORE, mode);
        var rq = fn(tx.objectStore(IDB_STORE));
        tx.oncomplete = function () { resolve(rq && 'result' in rq ? rq.result : undefined); };
        tx.onerror = function () { reject(tx.error); };
        tx.onabort = function () { reject(tx.error || new Error('idb abort')); };
      });
    });
  }
  function _photoClear() {
    _idbSaved = {};
    return _idbTx('readwrite', function (s) { return s.clear(); }).catch(function () {});
  }
  function _photoWarn() {
    if (_idbWarned) return;
    _idbWarned = true;
    notify('Fotoğrafların bu tarayıcıya kaydedilemedi — sayfayı kapatırsan fotoğrafı yeniden yüklemen gerekir.', 'warning', { duration: 7000 });
  }

  // ── Auto-save (localStorage debounce) ─────────────────────
  var saveTimer = null;
  function _pruneFotoSrc(json) {
    // Foto base64 src'leri localStorage'a yazma — quota taşmasın; veri IndexedDB'ye gider (yukarida).
    // toJSON excludeFromExport nesneleri (safe-zone kilavuzu) atlar -> canli liste ayni filtreyle hizalanir.
    var live = canvas ? canvas.getObjects().filter(function (o) { return o && !o.excludeFromExport; }) : [];
    var keep = {};
    if (json && json.objects) {
      json.objects.forEach(function (o, i) {
        if (o && o.type === 'image' && typeof o.src === 'string' && o.src.length > 1024) {
          var id = o.jkPhotoId;
          if (!id && live[i] && live[i].type === 'image') {
            id = live[i].jkPhotoId = 'jkp_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
            o.jkPhotoId = id;
          }
          if (id) {
            keep[id] = true;
            var len = o.src.length;
            if (_idbSaved[id] !== len && _idbSaved[id] !== 'p' + len) {
              _idbSaved[id] = 'p' + len;
              (function (id, src, len) {
                _idbTx('readwrite', function (s) { return s.put(src, id); }).then(function () {
                  if (_idbSaved[id] === 'p' + len) _idbSaved[id] = len;
                }, function (e) {
                  if (_idbSaved[id] === 'p' + len) delete _idbSaved[id];
                  console.warn('[JetAtolye] taslak foto IndexedDB yazilamadi', e);
                  _photoWarn();
                });
              })(id, o.src, len);
            }
          }
          o.src = '';
          o.jkPhotoMissingAfterReload = true;
        }
      });
    }
    // Tasarimda artik olmayan fotograflari IndexedDB'den sil
    _idbTx('readonly', function (s) { return s.getAllKeys(); }).then(function (keys) {
      var stale = (keys || []).filter(function (k) { return !keep[k]; });
      if (!stale.length) return;
      stale.forEach(function (k) { delete _idbSaved[k]; });
      return _idbTx('readwrite', function (s) { stale.forEach(function (k) { s.delete(k); }); return null; });
    }).catch(function () {});
    return json;
  }

  // Taslak geri yuklenmeden once bos src'li fotolari IndexedDB'den doldur; bulunamayanlari at.
  function _hydrateDraftPhotos(fabricJson) {
    var objs = (fabricJson && fabricJson.objects) || [];
    var need = objs.filter(function (o) { return o && o.type === 'image' && !o.src && o.jkPhotoId; });
    var loads = need.map(function (o) {
      return _idbTx('readonly', function (s) { return s.get(o.jkPhotoId); }).then(function (src) {
        if (typeof src === 'string' && src) {
          o.src = src;
          delete o.jkPhotoMissingAfterReload;
          _idbSaved[o.jkPhotoId] = src.length;
        }
      }, function () {});
    });
    return Promise.all(loads).then(function () {
      var missing = 0;
      var kept = objs.filter(function (o) {
        var bad = o && o.type === 'image' && !o.src;
        if (bad) missing++;
        return !bad;
      });
      var out = {};
      Object.keys(fabricJson || {}).forEach(function (k) { out[k] = fabricJson[k]; });
      out.objects = kept;
      return { json: out, missing: missing };
    });
  }

  function autoSave() {
    clearTimeout(saveTimer);
    if (state._draftPending) return;   // B-05: kayitli taslak hakkinda karar verilmeden uzerine yazma
    saveTimer = setTimeout(function () {
      if (state._draftPending) return;
      try {
        // F.6.9 fix: Fabric.js stylesToArray undefined fırlatıyor IText obje styles {} olmadığında
        canvas.getObjects().forEach(function(o) {
          if (o && (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox')) {
            if (!o.styles || typeof o.styles !== 'object') o.styles = {};
          }
        });
        var json = _stripModelClips(canvas.toJSON(JK_JSON_PROPS));
        // Kalite fix paketi 2026-05: foto src'leri büyük (3-10 MB base64),
        // localStorage 5MB limit — quota taşması engellemek için src'leri prune et.
        // Orijinal blob'lar zaten state.photoBlobs'da; high-res master export oradan gelir.
        json = _pruneFotoSrc(json);
        var draft = {
          version: 3,
          ts: Date.now(),
          model: state.model,
          modelBrand: state.modelBrand,
          modelSlug: state.modelSlug,
          modelConfirmed: state.modelConfirmed,
          productKey: state.productKey,                    // A7 (2026-09-25): F5 sonrasi kilif tipi kayboluyordu
          productKeyConfirmed: state.productKeyConfirmed,
          template: state.template,
          fabric: json,
        };
        try {
          localStorage.setItem('jetkilif:atolye_draft', JSON.stringify(draft));
          bus.emit('auto-save', draft);
        } catch (quotaErr) {
          // QuotaExceededError — eski draft'ı sil, sadece minimal state tut
          try { localStorage.removeItem('jetkilif:atolye_draft'); } catch (e) {}
          var minimal = {
            version: 3, ts: Date.now(), model: state.model, modelBrand: state.modelBrand,
            modelSlug: state.modelSlug, modelConfirmed: state.modelConfirmed,
            productKey: state.productKey, productKeyConfirmed: state.productKeyConfirmed,
            template: state.template, fabric: { objects: [], background: null }
          };
          try { localStorage.setItem('jetkilif:atolye_draft', JSON.stringify(minimal)); } catch (e2) {}
          console.warn('[JetAtolye] autoSave quota exceeded — fabric state pruned');
        }
      } catch (e) { console.warn('[JetAtolye] autoSave fail', e); }
    }, 600);
  }

  function loadDraft() {
    try {
      var raw = localStorage.getItem('jetkilif:atolye_draft');
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) { return null; }
  }

  // ── Photo input (shared by photos panel + first-time load) ───
  function setupPhotoInput() {
    var input = document.getElementById('ja-photo-input');
    if (!input) return;
    input.addEventListener('change', function (e) {
      var files = Array.from(e.target.files || []);
      files.forEach(function (file) {
        // Her foto'ya benzersiz id ata; original File blob state'te saklanır
        // (high-res master export için — canvas grid downsample'ı bypass eder)
        var photoId = 'jkp_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
        if (!state.photoBlobs) state.photoBlobs = {};
        state.photoBlobs[photoId] = file;

        var reader = new FileReader();
        reader.onload = function (ev) {
          fabric.Image.fromURL(ev.target.result, function (img) {
            if (!img) {
              console.error('[JetAtolye] image decode failed');
              return;
            }
            img.jkPhotoId = photoId; // toJSON'a dahil — restore'da photoBlobs ile eşleşir
            // Faz 5.5 (2026-05-06): DPI/cozunurluk soft-warning.
            // Print 2000x4000 hedef → kabaca <800px (en kucuk kenar) ise UV baskida pikselleme riski.
            var minSide = Math.min(img.width || 0, img.height || 0);
            if (minSide > 0 && minSide < 800) {
              notify(
                'Bu fotograf dusuk cozunurluklu (' + (img.width || '?') + 'x' + (img.height || '?')
                + 'px). UV baskida bulanik gorunebilir. Onerilen: 1500px+',
                'warning'
              );
            }
            // Faz J-9 (2026-05-07): SAFE INSET %6 + aspect-aware cover/fit.
            // Görsel test: silüet bbox'a tam cover photo'yu bezel chrome dışına taşırıyordu
            // (silüet bbox > visible bezel chrome). %6 inset photo'yu visible chrome içinde tutar.
            var P = getPrintBounds();
            // S17 B3 (2026-05-10): inset %8 → %12 (bezel chrome'u kapsa) + aspectMatch 0.80 → 0.65 (cover bias)
            var insetX = P.w * 0.12, insetY = P.h * 0.12;
            var safeW = P.w - 2 * insetX, safeH = P.h - 2 * insetY;
            var iw = img.width || 1, ih = img.height || 1;
            var coverScale = Math.max(safeW / iw, safeH / ih);
            var fitScale = Math.min(safeW / iw, safeH / ih);
            var photoAR = iw / ih, caseAR = safeW / safeH;
            var aspectMatch = Math.min(photoAR, caseAR) / Math.max(photoAR, caseAR);
            var scale = aspectMatch >= 0.65 ? coverScale : fitScale;
            img.set({
              originX: 'center',
              originY: 'center',
              scaleX: scale,
              scaleY: scale,
              left: P.cx,
              top: P.cy,
              lockUniScaling: true,
            });
            canvas.add(img);
            img.setCoords();
            canvas.setActiveObject(img);
            canvas.requestRenderAll();
          }, { crossOrigin: 'anonymous' });
        };
        reader.readAsDataURL(file);
      });
      input.value = '';
    });
  }

  // ── Rail panel toggle ────────────────────────────────────
  function setupRailPanels() {
    var rail = document.getElementById('ja-rail');
    if (!rail) return;
    var items = rail.querySelectorAll('.ja-rail__item');

    function applyPanel(panelId) {
      document.querySelectorAll('[data-jet-panel]').forEach(function (p) {
        var wrapper = p.closest('.shopify-section') || p;
        // empty string layout CSS display:none'i override etmez!
        // Explicit 'block' set et, gizleme icin 'none'.
        if (p.dataset.jetPanel === panelId) {
          wrapper.style.display = 'block';
        } else {
          wrapper.style.display = 'none';
        }
      });
    }

    items.forEach(function (it) {
      it.addEventListener('click', function () {
        var panel = it.dataset.panel;
        items.forEach(function (i) { i.classList.toggle('active', i === it); });
        state.activePanel = panel;
        bus.emit('panel-change', panel);
        applyPanel(panel);
      });
    });
    applyPanel(state.activePanel);
  }

  // ── Save + Add to Cart actions ───────────────────────────
  function setupShellActions() {
    document.querySelectorAll('[data-action="save-design"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        autoSave();
        // v2.8 (kullanici talebi): tik/check olmadan, altta ufak metin uyarisi
        // B-05: fotolar IndexedDB'ye yazilamiyorsa "geri acabilirsin" vaadi verilmez
        var hasPhoto = canvas && canvas.getObjects().some(function (o) { return o && o.type === 'image' && o.name !== '__jk_bg_layer' && (o.jkPhotoId || String((o.getSrc && o.getSrc()) || '').indexOf('data:') === 0); });
        showHintBottom((hasPhoto && (!window.indexedDB || _idbWarned))
          ? 'Tasarımın kaydedildi — fotoğraflar bu tarayıcıda saklanamıyor, sayfayı kapatırsan yeniden yüklemen gerekir'
          : 'Tasarımın bu cihaza kaydedildi — sayfayı kapatsan bile geri açabilirsin');
      });
    });
    document.querySelectorAll('[data-action="add-to-cart"]').forEach(function (btn) {
      btn.addEventListener('click', addToCart);
    });
  }

  // ── Add to cart — Cloudflare Worker upload + Cart API ─────
  var WORKER_URL = 'https://holy-surf-0e75jetkilif-preview.yusufardaben.workers.dev/';
  var CUSTOMIZER_VARIANT_ID = null; // tema-bazlı set edilir

  function getVariantId() {
    // v2.6: wizard variant-map (productKey + modelSlug -> variant_id) onceki tum yontemlere oncelikli
    if (typeof window.JetWizardGetVariantId === 'function') {
      var v = window.JetWizardGetVariantId();
      if (v) return v;
      // A2 (2026-09-25): harita bu model icin varyant vermediyse sayfa varsayilanina (meta ja-variant-id =
      // iPhone 15 Pro Max) DUSME — "— Model seç —" / haritasi inmemis model yanlis varyantla sepete gidiyordu.
      return null;
    }
    if (CUSTOMIZER_VARIANT_ID) return CUSTOMIZER_VARIANT_ID;
    var meta = document.querySelector('meta[name="ja-variant-id"]');
    if (meta) return parseInt(meta.content, 10);
    return null;
  }

  // ── Faz 4.3 (2026-05-06): Preview WebP exporter + uploader ───────
  // Browser-side WebP encode (canvas.toDataURL), Worker'a base64 olarak POST.
  // Endpoint: /upload/preview (Faz 4.2 yeni Worker). iOS<13 JPEG fallback.
  var _webpSupport = null; // null=henuz test edilmedi, true/false=cached
  function _testWebPSupport() {
    if (_webpSupport !== null) return Promise.resolve(_webpSupport);
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () { _webpSupport = (img.width === 1); resolve(_webpSupport); };
      img.onerror = function () { _webpSupport = false; resolve(false); };
      img.src = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
    });
  }

  // Faz 4.3: 800x1440 preview (multiplier=1.33 ile canvas 600x1080 → 798x1437).
  // Quality 0.92 — premium preview kalitesi, bandwidth dengeli (~200-400 KB).
  function exportPreviewBlob() {
    return _testWebPSupport().then(function (webp) {
      var format = webp ? 'webp' : 'jpeg';
      var mime = webp ? 'image/webp' : 'image/jpeg';
      var dataUrl = canvas.toDataURL({ format: format, quality: 0.92, multiplier: 1.33 });
      var b64 = dataUrl.split(',')[1] || '';
      return { base64: b64, mime: mime, format: format };
    });
  }

  // Faz 4.3: Preview Worker'a POST /upload/preview — anlık feedback (~2-3s).
  function uploadPreview(scope, preData) {
    return (preData ? Promise.resolve(preData) : exportPreviewBlob()).then(function (data) {
      var ctrl = new AbortController();
      var timeoutId = setTimeout(function () { ctrl.abort(); }, 30000);
      // C11 (2026-09-30): scope=cart → Worker cart/ (14 gun) — sepet kucuk resmi; varsayilan preview/ (24 saat)
      return fetch(WORKER_URL.replace(/\/+$/, '') + '/upload/preview' + (scope === 'cart' ? '?scope=cart' : ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: data.base64, mime: data.mime }),
        signal: ctrl.signal,
      })
        .then(function (r) {
          clearTimeout(timeoutId);
          if (!r.ok) throw new Error('preview upload HTTP ' + r.status);
          return r.json();
        })
        .catch(function (err) {
          clearTimeout(timeoutId);
          throw err;
        });
    });
  }

  // ── Faz 4.5 (2026-05-06): Background preview pre-upload (debounce + mutex) ──
  // Canvas dirty event'lerinde 2s sessizlik bekle → preview WebP upload (silent).
  // ATC anında: state.lastPreviewUrl varsa kullan, yoksa bg upload bittikten sonra ilerle.
  function _bgPreviewUpload() {
    if (state._bgPreviewActive) return;
    if (!state._previewDirty) return;
    if (state.canvasBlocked) return;
    if (!state.modelConfirmed) return; // model yoksa preview anlamsız
    state._bgPreviewActive = true;
    uploadPreview()
      .then(function (resp) {
        state.lastPreviewUrl = (resp && resp.url) || null;
        state._previewDirty = false;
        bus.emit('preview-uploaded', { url: state.lastPreviewUrl });
        state._bgPreviewActive = false;
      })
      .catch(function (err) {
        // Sessiz fallback — kullanici devam edebilir, ATC'de tekrar dener
        console.warn('[JetAtolye] bg preview upload fail', err);
        state._bgPreviewActive = false;
      });
  }

  function _setupBgPreviewListener() {
    if (!canvas) return;
    function markDirty() {
      state._previewDirty = true;
      if (state._bgPreviewTimer) clearTimeout(state._bgPreviewTimer);
      state._bgPreviewTimer = setTimeout(_bgPreviewUpload, 2000);
    }
    canvas.on('object:modified', markDirty);
    canvas.on('object:added', markDirty);
    canvas.on('object:removed', markDirty);
  }

  // ── 2026-08-14: PARCALI (MULTIPART) YUKLEME — "sepet pending kaldi" kok cozumu ────────
  // Olculen kok neden: 33 MB'lik baski dosyasi TEK istekte gonderiliyordu. Worker dosyayi
  // sorunsuz aliyor (3/3 basarili) ama hizli masaustunde bile ~10 sn suruyor. Turkiye mobil
  // yukleme hizlarinda: 10 Mbps→26 sn, 5 Mbps→53 sn, 3 Mbps→88 sn. 60 sn timeout'u asinca
  // AbortError → "Baglanti yavas — sepet pending kaldi" → musteri satin alamiyor.
  // Cozum: worker'da HAZIR duran /upload/multipart/* yoluna gec. Her parca 5 MB → zayif
  // baglantida bile ~13 sn. Parca basina 3 deneme retry → tek parca duserse bastan baslamaz.
  var MP_PART_RAW = 5 * 1024 * 1024;        // R2 kurali: son haric tum parcalar esit ve >=5 MiB
  var MP_THRESHOLD_B64 = 6 * 1024 * 1024;   // altinda tek-atis yol (hizli, kanitli)

  function _b64ToBytes(b64) {
    var bin = atob(b64);
    var out = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  }

  function _bytesToB64(bytes) {
    var CH = 0x8000, s = [];
    for (var i = 0; i < bytes.length; i += CH) {
      s.push(String.fromCharCode.apply(null, bytes.subarray(i, i + CH)));
    }
    return btoa(s.join(''));
  }

  function _mpFetch(path, payload, timeoutMs) {
    var ctrl = new AbortController();
    var to = setTimeout(function () { ctrl.abort(); }, timeoutMs || 45000);
    return fetch(WORKER_URL.replace(/\/+$/, '') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: ctrl.signal,
    }).then(function (r) {
      clearTimeout(to);
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(path + ' HTTP ' + r.status + ' ' + ((j && j.error) || ''));
        return j;
      });
    }, function (e) { clearTimeout(to); throw e; });
  }

  // Tek parca 3 denemeye kadar tekrar (yavas/kopan mobil baglanti icin)
  function _mpPartWithRetry(key, uploadId, partNumber, b64, attempt) {
    attempt = attempt || 1;
    return _mpFetch('/upload/multipart/part', {
      uploadId: uploadId, key: key, partNumber: partNumber, body: b64,
    }).catch(function (err) {
      if (attempt >= 3) throw err;
      console.warn('[JetAtolye] parca ' + partNumber + ' deneme ' + attempt + ' basarisiz, tekrar:', err && err.message);
      return new Promise(function (res) { setTimeout(res, 1000 * attempt); })
        .then(function () { return _mpPartWithRetry(key, uploadId, partNumber, b64, attempt + 1); });
    });
  }

  function uploadMultipart(rawBase64) {
    var bytes = _b64ToBytes(rawBase64);
    var total = Math.ceil(bytes.length / MP_PART_RAW);
    var idem = 'jk-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    console.log('[JetAtolye] multipart basliyor: ' + (bytes.length / 1048576).toFixed(1) + ' MB, ' + total + ' parca');
    return _mpFetch('/upload/multipart/init', {
      folder: 'cart', contentType: 'image/png', idempotencyKey: idem,
    }).then(function (init) {
      var parts = [];
      var chain = Promise.resolve();
      for (var i = 0; i < total; i++) {
        (function (idx) {
          chain = chain.then(function () {
            var slice = bytes.subarray(idx * MP_PART_RAW, Math.min((idx + 1) * MP_PART_RAW, bytes.length));
            return _mpPartWithRetry(init.key, init.uploadId, idx + 1, _bytesToB64(slice))
              .then(function (p) {
                parts.push({ partNumber: p.partNumber, etag: p.etag });
                console.log('[JetAtolye] parca ' + (idx + 1) + '/' + total + ' tamam');
              });
          });
        })(i);
      }
      return chain.then(function () {
        return _mpFetch('/upload/multipart/complete', {
          uploadId: init.uploadId, key: init.key, parts: parts,
        });
      });
    }).then(function (done) {
      console.log('[JetAtolye] multipart tamamlandi:', done.url);
      return { url: done.url, filename: String(done.key || '').split('/').pop() };
    });
  }

  // BG2 fix (2026-04-29): Worker fetch'e 60s timeout + 1x retry + graceful fallback
  // 2026-05-01: 15→45→60s — master ~36 MB (multiplier=8 mockup) mobil 3G'de 30-50s alabilir.
  // 2026-08-14: Esigi asan dosya PARCALI yola gider. Olcum: 33 MB tek istek, hizli masaustunde
  // ~10 sn; 5 Mbps mobilde 53 sn, 3 Mbps'de 88 sn → 60 sn timeout'u asip "sepet pending kaldi"
  // veriyordu. Parcali yolda her parca 5 MB (~13 sn @3 Mbps) ve parca basina 3 deneme var.
  function uploadToWorkerWithRetry(rawBase64, attempt) {
    attempt = attempt || 1;
    if (attempt === 1 && rawBase64.length > MP_THRESHOLD_B64) {
      return uploadMultipart(rawBase64);
    }
    var ctrl = new AbortController();
    var timeoutId = setTimeout(function () { ctrl.abort(); }, 60000);
    return fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image: rawBase64, mime: 'image/png' }),
      signal: ctrl.signal,
    })
      .then(function (r) {
        clearTimeout(timeoutId);
        if (!r.ok && r.status >= 500 && attempt < 2) {
          // 5xx hata: 1x retry
          return uploadToWorkerWithRetry(rawBase64, attempt + 1);
        }
        return r.json();
      })
      .catch(function (err) {
        clearTimeout(timeoutId);
        if (err.name === 'AbortError' && attempt < 2) {
          // timeout: 1x retry
          return uploadToWorkerWithRetry(rawBase64, attempt + 1);
        }
        throw err;
      });
  }

  // ── High-res master render (kayıpsız foto) ───────────────────────
  // canvas grid 600×1080 — müşteri foto'ları cover-scale ile downsample edilir.
  // Sepete ekle anında orijinal File blob'ları (state.photoBlobs) ile foto element'lerini
  // GEÇİCİ olarak swap edip multiplier=8 ile render et → restore. Layer transform aynı,
  // sadece pixel kaynağı yüksek-res. Sonuç: 4800×8640 PNG, print area ~3920×7680, ~1344 DPI.
  function _loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function (e) { reject(new Error('image load fail')); };
      img.src = src;
    });
  }

  // 02 frame URL'i state.modelSlug için JET_FRAME_PAIRS'tan al
  function _getFrame02Url() {
    try {
      var slug = state.modelSlug;
      if (!slug || !window.JET_FRAME_PAIRS) return null;
      var pair = window.JET_FRAME_PAIRS[slug];
      return (pair && pair.url_02) || null;
    } catch (e) { return null; }
  }

  // S27v19 (2026-05-22): 01 frame URL'i (print area silüet PNG, alpha mask için)
  function _getFrame01Url() {
    try {
      var slug = state.modelSlug;
      if (!slug || !window.JET_FRAME_PAIRS) return null;
      var pair = window.JET_FRAME_PAIRS[slug];
      return (pair && pair.url_01) || null;
    } catch (e) { return null; }
  }

  function exportMaster() {
    return new Promise(function (resolve) {
      var photoObjects = canvas.getObjects().filter(function (o) {
        return o && o.type === 'image' && o.jkPhotoId && state.photoBlobs && state.photoBlobs[o.jkPhotoId];
      });

      // 1) Foto src swap (kayıpsız high-res)
      var swapped = [];
      var photoLoadPromises = photoObjects.map(function (obj) {
        var blob = state.photoBlobs[obj.jkPhotoId];
        var blobUrl = URL.createObjectURL(blob);
        return _loadImage(blobUrl).then(function (hiRes) {
          swapped.push({ obj: obj, oldElement: obj._element, oldOriginal: obj._originalElement, blobUrl: blobUrl });
          obj._element = hiRes;
          obj._originalElement = hiRes;
        }).catch(function (e) {
          URL.revokeObjectURL(blobUrl);
          console.warn('[JetAtolye] master photo load fail', obj.jkPhotoId, e);
        });
      });

      // 2) 02 frame overlay yükle (mockup formatı için telefon silüet + kamera modülü)
      var frame02Url = _getFrame02Url();
      var framePromise = frame02Url ? _loadImage(frame02Url).catch(function (e) {
        console.warn('[JetAtolye] master frame02 load fail', e);
        return null;
      }) : Promise.resolve(null);

      Promise.all(photoLoadPromises.concat([framePromise])).then(function (results) {
        var frameImg = results[results.length - 1]; // son element framePromise

        // 02 overlay'i canvas'a EN ÜSTE ekle (multiplier=8 ile render edilirken).
        // Kendi clipPath'i = full canvas → canvas-level clipPath bypass → tam siluet görünür.
        // Diğer objelerde object-level clipPath aktif → tasarım hala print area içinde clip.
        var frameOverlay = null;
        if (frameImg) {
          frameOverlay = new fabric.Image(frameImg, {
            left: 0, top: 0,
            originX: 'left', originY: 'top',
            scaleX: CANVAS_W / frameImg.width,
            scaleY: CANVAS_H / frameImg.height,
            selectable: false, evented: false,
            name: '__jk_frame_overlay_export',
            clipPath: new fabric.Rect({
              left: 0, top: 0, width: CANVAS_W, height: CANVAS_H,
              absolutePositioned: true,
            }),
          });
          canvas.add(frameOverlay);
          canvas.bringToFront(frameOverlay);
        }

        canvas.requestRenderAll();
        // Bir frame bekle — render tamamlansın
        requestAnimationFrame(function () {
          var dataUrl;
          try {
            // multiplier=8 → 4800×8640 (print area ~3920×7680 → ~1422 DPI ULTRA premium).
            // Kullanıcı kararı 2026-05-01: kalite ön planda, upload arka plana taşındı
            // (optimistic cart add → background master upload → cart property update).
            dataUrl = canvas.toDataURL({ format: 'png', quality: 1, multiplier: 8 });
          } finally {
            // Restore — 02 frame overlay sil, foto element'lerini eski hâline al
            if (frameOverlay) {
              try { canvas.remove(frameOverlay); } catch (e) {}
            }
            swapped.forEach(function (s) {
              s.obj._element = s.oldElement;
              s.obj._originalElement = s.oldOriginal;
              URL.revokeObjectURL(s.blobUrl);
            });
            canvas.requestRenderAll();
          }
          resolve(dataUrl);
        });
      });
    });
  }

  // ── Faz 4.4 (2026-05-06): Print-ready export (frame overlay YOK) ──
  // exportMaster mockup icin (telefon silueti + kamera dahil — preview/social).
  // exportPrint UV baskiya gider — sadece musteri tasarimi + clipPath kesimi.
  // Frame layer asla EKLENMEZ → telefon gorseli baskida cikmaz.
  // Plan: 2000x4000 PNG sRGB hedef (multiplier=3.33, canvas 600x1080 → 1998x3596).
  function exportPrint() {
    return new Promise(function (resolve) {
      var photoObjects = canvas.getObjects().filter(function (o) {
        return o && o.type === 'image' && o.jkPhotoId && state.photoBlobs && state.photoBlobs[o.jkPhotoId];
      });
      var swapped = [];
      var photoLoadPromises = photoObjects.map(function (obj) {
        var blob = state.photoBlobs[obj.jkPhotoId];
        var blobUrl = URL.createObjectURL(blob);
        return _loadImage(blobUrl).then(function (hiRes) {
          swapped.push({ obj: obj, oldElement: obj._element, oldOriginal: obj._originalElement, blobUrl: blobUrl });
          obj._element = hiRes;
          obj._originalElement = hiRes;
        }).catch(function (e) {
          URL.revokeObjectURL(blobUrl);
          console.warn('[JetAtolye] print photo load fail', obj.jkPhotoId, e);
        });
      });
      // FRAME OVERLAY YOK — bu exportPrint'in tek farki
      Promise.all(photoLoadPromises).then(function () {
        canvas.requestRenderAll();
        requestAnimationFrame(function () {
          var dataUrl;
          try {
            // multiplier=3.33: 600*3.33=1998, 1080*3.33=3596 — print 300 DPI hedef
            // Faz 4.5'te imageSmoothingQuality=high bandgap reduce
            dataUrl = canvas.toDataURL({ format: 'png', quality: 1, multiplier: 3.33 });
          } finally {
            swapped.forEach(function (s) {
              s.obj._element = s.oldElement;
              s.obj._originalElement = s.oldOriginal;
              URL.revokeObjectURL(s.blobUrl);
            });
            canvas.requestRenderAll();
          }
          resolve(dataUrl);
        });
      });
    });
  }

  // ── 2026-08-14: ADAPTIF BOYUT — "her tasarim yuklensin" ──────────────────
  // Kok neden (canlida olculdu): sabit multiplier=8 ile fotografli tasarim 88 MB base64 uretiyordu.
  // Worker tek-parca limiti 60 MB → 413 "file too large" → 413 bir 5xx olmadigi icin retry de
  // tetiklenmiyordu → "Tasarim yuklenemedi — sepet pending kaldi" → musteri satin alamiyordu.
  // Cozum: baski kafasi hedefiyle (Epson 1080 DPI) basla; dosya CAP'i asarsa multiplier'i
  // OLCULEN boyut oranindan turetip yeniden render et. Kalite yalnizca gerektiginde duser.
  // DPI ~= multiplier * 165  (mult 8 = ~1322 DPI, mult 6.5 = ~1074 DPI, mult 3 = ~496 DPI)
  var R2_TARGET_MULT = 6.5;                 // Epson 1080 DPI baski kafasi hedefi
  var R2_MIN_MULT = 3.0;                    // ~496 DPI — kalite tabani, altina asla inme
  var R2_CAP_B64 = 34 * 1024 * 1024;        // ~34 MB base64 (worker limiti 60 MB — guvenli pay)

  // 2026-09-29 (#1047): fabric toDataURL = toCanvasElement(mult) + el.toDataURL('image/png', 1)
  // (fabric-5.3.0.min.js, birebir). Ayri cagiriyoruz ki ~27 M piksellik export canvas'i is biter bitmez
  // birakilsin — fabric onu birakmiyor, iOS Safari'de GPU bellegi birikiyordu.
  function _r2Render(mult) {
    var saved = {
      w: canvas.width, h: canvas.height, vpt: canvas.viewportTransform,
      rs: canvas.enableRetinaScaling, ct: canvas.contextTop, it: canvas.interactive,
    };
    var el;
    try {
      el = canvas.toCanvasElement(mult, { left: 0, top: 0, width: CANVAS_W, height: CANVAS_H });
    } catch (e) {
      // toCanvasElement'te try/finally yok: renderCanvas patlarsa gecici boyut/transform kanvasta kalirdi
      canvas.width = saved.w; canvas.height = saved.h; canvas.viewportTransform = saved.vpt;
      canvas.enableRetinaScaling = saved.rs; canvas.contextTop = saved.ct; canvas.interactive = saved.it;
      canvas.calcViewportBoundaries();
      throw e;
    }
    try {
      return el.toDataURL('image/png', 1);
    } finally {
      el.width = 0;
      el.height = 0;
    }
  }

  // ── 2026-09-29 (#1047): CIKTI DOGRULAMA — "1x1 dosya 'yuklendi' oldu" ──────────────────
  // iOS Safari buyuk export canvas'ini olusturamayinca hata vermiyor, 1x1 opak siyah PNG donduruyor
  // (WebKit RemoteNativeImageProxy placeholder). Eskiden yalniz "fazla buyuk mu" bakiliyordu; bu
  // dosya R2'ye yuklendi, sepete "✓ Yuklendi" yazildi, taslak silindi, bos baski dosyasiyla odendi.
  // PNG IHDR'si (ilk 24 bayt = 32 base64 karakter) okunur; boyut multiplier'la tutmali.
  var R2_MIN_W = Math.floor(CANVAS_W * R2_MIN_MULT) - 2;   // 1798
  var R2_MIN_H = Math.floor(CANVAS_H * R2_MIN_MULT) - 2;   // 3238
  var R2_RETRY_MULTS = [5.0, 3.0];  // yalniz gecersiz ciktidan sonra; mutlu yolda hic calismaz

  function _r2PngDims(dataUrl) {
    var P = 'data:image/png;base64,';
    if (typeof dataUrl !== 'string' || dataUrl.indexOf(P) !== 0) return null;
    var b;
    try { b = atob(dataUrl.substr(P.length, 32)); } catch (e) { return null; }
    if (b.length < 24 || b.charCodeAt(0) !== 0x89 || b.substr(1, 3) !== 'PNG' || b.substr(12, 4) !== 'IHDR') return null;
    function u32(o) {
      return ((b.charCodeAt(o) << 24) | (b.charCodeAt(o + 1) << 16) | (b.charCodeAt(o + 2) << 8) | b.charCodeAt(o + 3)) >>> 0;
    }
    return { w: u32(16), h: u32(20) };
  }

  // Canvas genisligi ondalik atanir ve kesilir (600*5.6 = 3359.99 -> 3359) → floor + 2 px tolerans
  function _r2Valid(dataUrl, mult) {
    var d = _r2PngDims(dataUrl);
    if (!d) return false;
    if (Math.abs(d.w - Math.floor(CANVAS_W * mult)) > 2 || Math.abs(d.h - Math.floor(CANVAS_H * mult)) > 2) return false;
    return d.w >= R2_MIN_W && d.h >= R2_MIN_H && _r2B64Len(dataUrl) >= 4096;
  }

  function _r2B64Len(dataUrl) {
    var i = dataUrl.indexOf(',');
    return i < 0 ? dataUrl.length : dataUrl.length - i - 1;
  }

  // Hedef multiplier'da render et; CAP asilirsa kucultup tekrar dene.
  // PNG boyutu ~ piksel sayisi (multiplier^2) ile orantili → gereken multiplier oradan turetilir.
  // 2026-09-29: startMult (retry icin) alir, { dataUrl, mult } doner — dogrulama beklenen boyutu mult'tan hesaplar
  function _r2RenderAdaptive(startMult) {
    var mult = startMult || R2_TARGET_MULT;
    var dataUrl = _r2Render(mult);
    var len = _r2B64Len(dataUrl);
    for (var tries = 0; len > R2_CAP_B64 && mult > R2_MIN_MULT && tries < 3; tries++) {
      var next = mult * Math.sqrt(R2_CAP_B64 / len) * 0.95;
      next = Math.max(R2_MIN_MULT, Math.round(next * 10) / 10);
      if (next >= mult) break;
      console.warn('[JetAtolye] R2 export ' + (len / 1048576).toFixed(1) + ' MB > cap — multiplier ' + mult + ' -> ' + next);
      mult = next;
      dataUrl = _r2Render(mult);
      len = _r2B64Len(dataUrl);
    }
    console.log('[JetAtolye] R2 export: multiplier=' + mult + ' (~' + Math.round(mult * 165) + ' DPI), ' + (len / 1048576).toFixed(1) + ' MB');
    return { dataUrl: dataUrl, mult: mult };
  }

  // ── 2026-05-21 / S27v18 restore + S27v19 frame01-mask: exportForR2 — R2'ye yüklenen baskı dosyası ──
  // Mantık: exportPrint kopyası (frame02 overlay yok, foto blob swap aktif)
  //   + toDataURL crop ile PRINT area'ya kırp (left:55, top:60, w:490, h:960)
  //   + multiplier ADAPTIF (2026-08-14): hedef 6.5 (~1074 DPI, Epson 1080 kafaya denk),
  //     dosya 34 MB'i asarsa kademeli duser, taban 3.0 (~496 DPI) — bkz. _r2RenderAdaptive
  //   + S27v19: frame_01 PNG alpha mask uygulanır → output o modelin gerçek kasa silüetine clip
  //     (silüet içi opak design, dışı tamamen transparent). frame_01 fail olursa rect output fallback.
  // Sonuç: sadece müşteri tasarımı (foto+text+sticker+pattern), modelin silüetinde, saf baskı dosyası.
  // 2026-09-29 (#1047): render + dogrulama. Ilk deneme gecerliyse bugunku akisla ayni (ek is yok).
  // Gecersiz/istisna → restore edilmis durumda 400 ms bekle, daha kucuk mult ile tekrar (5.0, 3.0).
  // Hepsi gecersizse reject → startBackgroundUpload catch (C-3): satir silinir, odeme kilitli, taslak kalir.
  function exportForR2() {
    // Export boyunca arka plan onizleme render'i baslamasin (swap/clipPath=null durumunu gorurdu + ek bellek)
    if (state._bgPreviewTimer) { clearTimeout(state._bgPreviewTimer); state._bgPreviewTimer = null; }
    var mults = [R2_TARGET_MULT].concat(R2_RETRY_MULTS);

    function next(i) {
      if (i + 1 >= mults.length) {
        var ve = new Error('r2-render-invalid');
        ve.jkUser = 'Telefonun tasarımı hazırlarken zorlandı; tasarımın sepetten çıkarıldı ama atölyede duruyor. Diğer sekmeleri kapatıp "Sepete Ekle"ye tekrar bas.';
        throw ve;
      }
      return new Promise(function (res) { setTimeout(res, 400); }).then(function () { return attempt(i + 1); });
    }

    function attempt(i) {
      return _r2RenderOnce(mults[i]).then(function (r) {
        if (r && _r2Valid(r.dataUrl, r.mult)) return r.dataUrl;
        var d = r && _r2PngDims(r.dataUrl);
        console.warn('[JetAtolye] R2 render gecersiz (' + (d ? d.w + 'x' + d.h : 'okunamadi') + '), mult=' + (r ? r.mult : mults[i]));
        return next(i);
      }, function (e) {
        console.warn('[JetAtolye] R2 render hata, mult=' + mults[i], e);
        return next(i);
      });
    }

    return attempt(0);
  }

  // Tek render denemesi: foto swap → clipPath=null → rAF → adaptif render → HER durumda restore.
  function _r2RenderOnce(startMult) {
    return new Promise(function (resolve, reject) {
      var photoObjects = canvas.getObjects().filter(function (o) {
        return o && o.type === 'image' && o.jkPhotoId && state.photoBlobs && state.photoBlobs[o.jkPhotoId];
      });
      var swapped = [];
      var photoLoadPromises = photoObjects.map(function (obj) {
        var blob = state.photoBlobs[obj.jkPhotoId];
        var blobUrl = URL.createObjectURL(blob);
        return _loadImage(blobUrl).then(function (hiRes) {
          swapped.push({ obj: obj, oldElement: obj._element, oldOriginal: obj._originalElement, blobUrl: blobUrl });
          obj._element = hiRes;
          obj._originalElement = hiRes;
        }).catch(function (e) {
          URL.revokeObjectURL(blobUrl);
          console.warn('[JetAtolye] R2 photo load fail', obj.jkPhotoId, e);
        });
      });
      // S27v23 (2026-05-22): canvas.clipPath KALDIRILDI render sirasinda.
      // Sebep: Yusuf "fotograf yerlestirildigi gibi gorunsun, silhouette/frame yok" istedi.
      // Output = duz dikdortgen 4800×8640, kasa silueti yok, frame yok, sadece foto + sticker'lar.
      // canvas.clipPath render sonrasi restore edilir (atolye UI etkilemez).
      // FRAME 02 OVERLAY YOK (eskiden exportMaster'da vardi).
      Promise.all(photoLoadPromises).then(function () {
        var savedClipPath = canvas.clipPath;
        canvas.clipPath = null;
        var showTplSlots = _hideTplSlots();   // Sablon v2: bos yuva yer tutucusu basilmaz
        canvas.requestRenderAll();
        requestAnimationFrame(function () {
          var out = null, renderErr = null;
          try {
            // Full canvas crop (600×1080 × mult), silhouette YOK.
            out = _r2RenderAdaptive(startMult);
          } catch (e) {
            // Eskiden istisna rAF icinde firlayip promise'i sonsuza dek askida birakiyordu
            renderErr = e;
          } finally {
            // Restore clipPath (atolye UI render normal sekilde devam etsin)
            canvas.clipPath = savedClipPath;
            showTplSlots();
            swapped.forEach(function (s) {
              s.obj._element = s.oldElement;
              s.obj._originalElement = s.oldOriginal;
              URL.revokeObjectURL(s.blobUrl);
            });
            canvas.requestRenderAll();
          }
          if (renderErr) reject(renderErr); else resolve(out);
        });
      }).catch(reject);
    });
  }

  // ── Optimistic add to cart akışı (2026-05-01) ─────────────────
  // 1. Hemen pending placeholder URL ile cart/add.js → müşteri "✅ Eklendi" görür
  // 2. Buton/sayfa müşteri kullanımına serbest bırakılır (alışverişe devam edebilir)
  // 3. Arka planda: exportForR2 + worker upload (10-30 sn) — PRINT crop, frame YOK
  // 4. Master hazır → cart line item REMOVE + ADD with real URL (Shopify property update için)
  // 5. Silent toast "✓ Tasarım yüklendi"
  // Müşteri /cart sayfasına gitse bile: pending placeholder görünür + cart auto-polling

  var _bgUploadActive = false; // beforeunload guard

  function addToCart() {
    // Faz 3.2: Canvas frame fatal modali aktifken ATC engelli
    if (state.canvasBlocked) {
      notify('Frame yuklenemedi — sayfayi yenile', 'error');
      return;
    }
    // Faz 1.1: Mutex one-in-flight (cift-tik race condition onle)
    if (state._addingToCart) return;

    // Faz 1.1: 4-kosullu validation (model + kilif tipi)
    if (!state.modelConfirmed || !state.model) {
      notify('Once telefon modeli sec', 'error');
      if (window.JetModelModal && window.JetModelModal.open) {
        window.JetModelModal.open({ forceFirst: true });
      }
      return;
    }
    if (!state.productKeyConfirmed || !state.productKey) {
      notify('Lutfen kilif tipini secin', 'error');
      return;
    }

    // Faz H-B1: KVKK validation kaldirildi; disclosure ATC altinda inline metin (shell.liquid)

    // A2: varyant yoksa sepete EKLEME (eskiden meta varsayilanina dusup yanlis modelle ekliyordu)
    var vid = getVariantId();
    if (!vid) {
      var mapReady = typeof window.JetWizardGetVariantMap === 'function' && !!window.JetWizardGetVariantMap();
      notify(mapReady
        ? 'Bu model için kılıf bulunamadı — lütfen telefon modelini listeden yeniden seç.'
        : 'Kılıf seçenekleri henüz yüklenmedi — birkaç saniye sonra tekrar dene.', 'error');
      return;
    }

    // C-2 (2026-09-25): sepete eklenen tasarimin modeli/sablonu BU AN sabitlenir. Eskiden yukleme
    // bitince o anki state.model yaziliyordu -> yukleme surerken model degisirse varyant eski model,
    // "Telefon Modeli" yeni model oluyordu.
    var snap = { model: state.model, slug: state.modelSlug, template: state.template, ts: Date.now(), sig: _designSig() };
    // C11 (2026-09-30): sepet kucuk resmi icin ~300 KB onizleme BU AN (taze) alinir, cart/ altina yuklenir.
    // Sepete eklemeyi BEKLETMEZ; yukleme bitince updateCartLineProperties setine _PreviewUrl olarak girer.
    // Hata/zaman asimi → null (kucuk resim _CustomCaseUrl'e duser, baski akisi etkilenmez).
    snap.previewP = _cartPreviewUrl();

    state._addingToCart = true;
    var btn = document.querySelector('[data-action="add-to-cart"]');
    if (btn) btn.disabled = true;

    // ADIM 1: Hemen optimistic cart/add (pending URL)
    var fd = new FormData();
    fd.append('id', String(vid));
    fd.append('quantity', '1');
    fd.append('properties[Telefon Modeli]', snap.model || '');
    // 2026-08-20: Alt cizgiyle baslayan ozellikleri Shopify odeme sayfasinda GIZLIYOR.
    // Musteri tasariminin kayboldugunu sanip odemeyi birakiyordu (14 gunde 64 terk edilmis
    // sepet). Alt cizgisiz bu alan odeme sayfasinda ve sipariste GORUNUR.
    fd.append('properties[Tasarım]', '⏳ Hazırlanıyor…');
    fd.append('properties[_CustomCaseUrl]', 'pending');
    fd.append('properties[_CustomCaseFile]', 'pending');
    fd.append('properties[_PendingUpload]', '1');
    fd.append('properties[_CustomImageData]', JSON.stringify({
      template: snap.template,
      model: snap.model,
      ts: snap.ts,
    }));
    // Sablon v2 (2026-10-03): hangi sablonun sattigi olculsun (alt cizgi = odeme sayfasinda gizli)
    if (snap.template) fd.append('properties[_TemplateId]', String(snap.template));

    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || !j || !j.key) throw new Error((j && (j.description || j.message)) || ('cart/add HTTP ' + r.status));
          return j;
        });
      })
      .then(function (lineItem) {
        if (lineItem && lineItem.errors) throw new Error(lineItem.errors);
        // Notyf mesaji innerHTML ile basar -> dinamik model adi kacislanir
        notify('✅ Sepete eklendi (' + _esc(snap.model || '') + ') — tasarımın arka planda yükleniyor', 'success');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (btn) btn.disabled = false; // Müşteri başka tasarım/ürün için serbest
        state._addingToCart = false;   // Faz 1.1: mutex release (success)
        // ADIM 2: Background upload + cart update
        return startBackgroundUpload(lineItem, snap);
      })
      .catch(function (err) {
        console.error('[JetAtolye] optimistic add error', err);
        notify('Sepete eklenirken hata oluştu — tekrar dene', 'error');
        if (btn) btn.disabled = false;
        state._addingToCart = false;   // Faz 1.1: mutex release (error)
      });
  }

  function startBackgroundUpload(pendingLine, snap) {
    snap = snap || { model: state.model, slug: state.modelSlug, template: state.template, ts: Date.now(), sig: _designSig() };
    _bgUploadActive = true;
    // ── 2026-08-14: EKSIK SINYALLER — "Hemen Satin Al" kilitli kalma kok nedeni ──────
    // sections/jet-atolye-shell.liquid su 3 olayi DINLIYOR ve su 2 global bayragi OKUYOR,
    // ama core bunlarin hicbirini gondermiyordu. Sonuc: musteri "Hemen Satin Al"a basinca
    // buton "Tasarim hazirlaniyor..." olup KILITLENIYOR; yukleme basariyla bitse bile
    // jet:upload-complete gelmedigi icin checkout'a ASLA gitmiyordu.
    // Sepete Ekle yolu etkilenmedigi icin onceki testlerde gorunmedi.
    window.__jet_uploadInProgress = true;
    window.__jet_uploadComplete = false;
    document.dispatchEvent(new CustomEvent('jet:upload-start'));
    // Non-blocking modal: 5 mesajlı animasyon (3 sn aralık), "Alışverişe devam et" butonu
    var bgModal = showBackgroundProgressModal();

    // photoBlobs snapshot — exportForR2 bunları kullanır
    var photoBlobsSnapshot = Object.assign({}, state.photoBlobs);

    // S27v18 (2026-05-22): exportMaster → exportForR2 (PRINT crop + multiplier=8 + frame YOK).
    // exportMaster bezel+kamera dahil tüm canvas'i render ediyordu, R2'ye yanlış asset (frame'li mockup) gidiyordu.
    return Promise.resolve()
      .then(function () {
        // C-2: sepete ekleme ile baski dosyasinin render'i arasinda model degistiyse durdur
        // (nesne kesimleri yeni modele gecmis olur, varyant eski modelde kalirdi).
        if (state.modelSlug !== snap.slug) {
          var me = new Error('model-changed');
          me.jkUser = 'Tasarımın yüklenirken telefon modeli değişti; eski satır sepetten çıkarıldı. Tasarımını yeni modelle tekrar sepete ekle.';
          throw me;
        }
        return exportForR2();
      })
      .then(function (dataUrl) {
        // 2026-09-29 (#1047) son kapi: gecerli ve yeterli boyutta PNG degilse YUKLEME YOK
        // (asagidaki taslak/foto silme adimlarina da gelinmez → musterinin tasarimi korunur)
        var pd = _r2PngDims(dataUrl);
        if (!pd || pd.w < R2_MIN_W || pd.h < R2_MIN_H) {
          var ge = new Error('r2-invalid-before-upload ' + (pd ? pd.w + 'x' + pd.h : 'okunamadi'));
          ge.jkUser = 'Telefonun tasarımı hazırlarken zorlandı; tasarımın sepetten çıkarıldı ama atölyede duruyor. Diğer sekmeleri kapatıp "Sepete Ekle"ye tekrar bas.';
          throw ge;
        }
        var rawBase64 = dataUrl.replace(/^data:image\/[a-z]+;base64,/, '');
        try { localStorage.setItem('jetkilif:atolye_pending_upload', JSON.stringify({ ts: Date.now(), b64Length: rawBase64.length })); } catch (e) {}
        return uploadToWorkerWithRetry(rawBase64);
      })
      .then(function (out) {
        if (!out || !out.url) throw new Error('Worker upload fail (no URL in response)');
        // ADIM 3: Cart line item'ı yeni properties ile REPLACE et
        // Shopify cart/change.js properties update destekliyor (2024+).
        // Fallback: REMOVE + ADD (line key değişir).
        // C-2: ozellikler sepete ekleme anindaki modelden (snap) — yukleme surerken degisen state'ten degil
        var props = {
          'Telefon Modeli': snap.model || '',
          'Tasarım': '✓ Yüklendi',
          '_CustomCaseUrl': out.url,
          '_CustomCaseFile': out.filename || '',
          '_CustomImageData': JSON.stringify({ template: snap.template, model: snap.model, ts: snap.ts }),
        };
        if (snap.template) props._TemplateId = String(snap.template);   // Sablon v2: set satiri TUMDEN degistirir
        // C11: bu set satirin ozelliklerini TUMDEN degistirir → _PreviewUrl burada da yazilmali
        return _withTimeout(snap.previewP, 8000).then(function (pv) {
          if (pv) props._PreviewUrl = pv;
          return updateCartLineProperties(pendingLine.key, props);
        });
      })
      .then(function () {
        try { localStorage.removeItem('jetkilif:atolye_pending_upload'); } catch (e) {}
        try { localStorage.removeItem('jetkilif:atolye_draft'); } catch (e) {}
        _photoClear();
        state.photoBlobs = {};
        _uploadedSig = snap.sig;   // C-1: "Hemen Satin Al" bu imzayla karsilastirir
        notify('✓ Tasarımın yüklendi', 'success');
        // 2026-08-14: shell state machine bunu bekliyor — gelmezse "Hemen Satin Al"
        // kilitli kalir ve checkout'a gecis olmaz.
        // SIRA ONEMLI: jet:upload-complete dinleyicisi SENKRON calisir ve checkout'a
        // yonlendirir. _bgUploadActive .finally'de temizlenirse o an hala true olur ve
        // beforeunload korumasi "Sayfadan ayrilmak istiyor musun?" diyalogu cikarir.
        // Bu yuzden bayragi olaydan ONCE dusuruyoruz.
        _bgUploadActive = false;
        window.__jet_uploadInProgress = false;
        window.__jet_uploadComplete = true;
        document.dispatchEvent(new CustomEvent('jet:upload-complete'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // S27v20 (2026-05-22): bgModal kapatma yerine success state'e cevir (Sepete Git CTA persist)
        if (bgModal && bgModal.success) bgModal.success();
      })
      .catch(function (err) {
        console.error('[JetAtolye] background upload error', err);
        // C-3 (2026-09-25): dosyasi olmayan "pending" satir sepette KALMAZ (odeme yapilirsa baski dosyasiz
        // siparis olurdu; tekrar deneme ikinci pending satir aciyordu). Mesajda "pending" jargonu yok.
        var msg = (err && err.jkUser) ? err.jkUser
          : (err && err.name === 'AbortError')
            ? 'Bağlantı yavaş olduğu için tasarımın yüklenemedi; sepetten çıkarıldı. Bağlantını kontrol edip "Sepete Ekle"ye tekrar bas.'
            : 'Tasarımın yüklenemedi; sepetten çıkarıldı. Lütfen "Sepete Ekle"ye tekrar bas.';
        _removePendingLine(pendingLine && pendingLine.key, snap.ts).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
        notify(msg, 'error', { duration: 9000 });
        // 2026-08-14: hata halinde de sinyal sart — yoksa butonlar kilitli kalir.
        window.__jet_uploadInProgress = false;
        window.__jet_uploadComplete = false;
        document.dispatchEvent(new CustomEvent('jet:upload-error'));
        if (bgModal && bgModal.close) bgModal.close();
      })
      .finally(function () {
        _bgUploadActive = false;
        // S27v20: success path success() ile state'i degistirir, close YOK.
        // Error path catch'te kapatildi. .finally sadece flag temizler.
      });
  }

  // C11 (2026-09-30): sepet onizlemesi — hata firlatmaz, URL ya da null doner
  function _cartPreviewUrl() {
    try {
      if (!canvas) return Promise.resolve(null);
      // Kucuk resim ~400 px yeter; beyaz zemin (JPEG'de seffaf=siyah olmasin). iPhone Safari WebP KODLAYAMAZ,
      // toDataURL('image/webp') PNG doner (~1-2 MB) → WebP degilse JPEG'e dus. Senkron: tasarim BU ANKI hali.
      var sv = { w: canvas.width, h: canvas.height, vpt: canvas.viewportTransform, rs: canvas.enableRetinaScaling, ct: canvas.contextTop, it: canvas.interactive };
      var el;
      var showTplSlots = _hideTplSlots();   // Sablon v2
      try {
        el = canvas.toCanvasElement(0.66, { left: 0, top: 0, width: CANVAS_W, height: CANVAS_H });
        showTplSlots();
      } catch (e1) {
        showTplSlots();
        // _r2Render ile ayni: toCanvasElement yarida kalirsa kanvas durumunu geri yukle
        canvas.width = sv.w; canvas.height = sv.h; canvas.viewportTransform = sv.vpt;
        canvas.enableRetinaScaling = sv.rs; canvas.contextTop = sv.ct; canvas.interactive = sv.it;
        canvas.calcViewportBoundaries();
        return Promise.resolve(null);
      }
      var c2 = document.createElement('canvas');
      c2.width = el.width; c2.height = el.height;
      var x2 = c2.getContext('2d');
      x2.fillStyle = '#FFFFFF'; x2.fillRect(0, 0, c2.width, c2.height); x2.drawImage(el, 0, 0);
      el.width = 0; el.height = 0;
      var d = c2.toDataURL('image/webp', 0.85);
      if (d.indexOf('data:image/webp') !== 0) d = c2.toDataURL('image/jpeg', 0.85);
      c2.width = 0; c2.height = 0;
      if (d.indexOf('data:image/') !== 0 || d.length < 64) return Promise.resolve(null);
      var pre = { base64: d.split(',')[1] || '', mime: d.slice(5, d.indexOf(';')) };
      return uploadPreview('cart', pre).then(function (r) {
        return (r && typeof r.url === 'string' && r.url.indexOf(WORKER_URL.replace(/\/+$/, '') + '/i/') === 0) ? r.url : null;
      }, function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }
  function _withTimeout(p, ms) {
    return new Promise(function (res) {
      var t = setTimeout(function () { res(null); }, ms);
      Promise.resolve(p).then(function (v) { clearTimeout(t); res(v); }, function () { clearTimeout(t); res(null); });
    });
  }

  // C-5 (2026-09-25): satir TEK istekte guncellenir — /cart/change.js + properties (tum ozellikleri
  // degistirir, adet korunur; canlida olculdu). Eskiden "once sil sonra ekle" + r.ok kontrolu yoktu:
  // ekleme basarisizsa satir tamamen siliniyor, musteriye yine "✓ yuklendi" deniyordu.
  function updateCartLineProperties(lineKey, newProps) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, properties: newProps }),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error('cart/change HTTP ' + r.status + ' ' + ((j && (j.description || j.message)) || ''));
        var ok = (j.items || []).some(function (it) {
          return it.properties && it.properties._CustomCaseUrl === newProps._CustomCaseUrl;
        });
        if (!ok) throw new Error('cart/change: guncel satir sepette bulunamadi');
        return j;
      });
    });
  }

  // C-3: basarisiz yuklemenin bekleyen satirini kaldir. Anahtar degismisse ts ile eslesen pending satir aranir.
  function _removePendingLine(lineKey, ts) {
    function removeKey(k) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: k, quantity: 0 }),
      }).then(function (r) { return r.ok; }, function () { return false; });
    }
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).find(function (it) {
        var p = it.properties || {};
        if (p._PendingUpload !== '1') return false;
        if (lineKey && it.key === lineKey) return true;
        try { return ts && JSON.parse(p._CustomImageData || '{}').ts === ts; } catch (e) { return false; }
      });
      return line ? removeKey(line.key) : true;
    }).catch(function () { return false; });
  }

  // C-1 (2026-09-25): sepete eklenen tasarimin imzasi. "Hemen Satin Al", ilk eklemeden sonra
  // tasarim/model degistiyse guncel tasarimi eklemeden /checkout'a gidiyordu (bayrak yalniz resetAll'da dusuyordu).
  var _uploadedSig = null;
  function _designSig() {
    if (!canvas) return '';
    try {
      var j = canvas.toJSON(JK_JSON_PROPS);
      delete j.clipPath;
      (j.objects || []).forEach(function (o) {
        if (!o) return;
        delete o.clipPath;
        if (typeof o.src === 'string' && o.src.length > 256) o.src = o.src.length + ':' + o.src.slice(-48);
      });
      return [state.modelSlug || '', state.productKey || '', JSON.stringify(j)].join('|');
    } catch (e) { return 'x' + Date.now(); }
  }
  // Kabuktaki (jet-atolye-shell) buyNow dinleyicisi butonun kendisinde; document capture ondan ONCE calisir.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.ja-shell__buy-now');
    if (!b || b.disabled) return;
    if (window.__jet_uploadComplete === true && _uploadedSig !== null && _designSig() !== _uploadedSig) {
      window.__jet_uploadComplete = false;   // degisen tasarim once sepete eklensin
    }
  }, true);

  // Non-blocking progress modal — müşteri "Alışverişe devam et" diyebilir
  function showBackgroundProgressModal() {
    var modal = document.createElement('div');
    modal.id = 'jk-bg-upload-modal';
    modal.innerHTML =
      '<div class="jk-bg-upload__inner">' +
        '<div class="jk-bg-upload__spinner"></div>' +
        '<h3 class="jk-bg-upload__title">Tasarımın hazırlanıyor</h3>' +
        '<p class="jk-bg-upload__msg" id="jk-bg-msg">Yüksek çözünürlükte işleniyor…</p>' +
        '<div class="jk-bg-upload__bar"><span></span></div>' +
        '<div class="jk-bg-upload__cta-row">' +
          '<button type="button" class="jk-bg-upload__close" id="jk-bg-close">Alışverişe devam et</button>' +
        '</div>' +
        '<small class="jk-bg-upload__hint">Tasarım arka planda yüklenmeye devam edecek</small>' +
      '</div>';
    modal.style.cssText =
      'position:fixed;right:20px;bottom:20px;z-index:10000;background:#fff;' +
      'border-radius:12px;box-shadow:0 8px 32px rgba(0,0,0,0.15);' +
      'padding:1rem 1.25rem;max-width:320px;font-family:inherit;border:1px solid #ECECEC;';
    // C-8 (2026-09-25): mobilde kutu alt cubugu (Model/Tip/Foto…) ortuyordu -> cubugun ustune
    try {
      var bb = document.querySelector('.jw__bottombar');
      if (bb && window.matchMedia('(max-width: 749px)').matches) {
        var bbH = Math.round(bb.getBoundingClientRect().height) || 60;
        modal.style.bottom = (bbH + 12) + 'px';
        modal.style.right = '12px';
        modal.style.left = '12px';
        modal.style.maxWidth = 'none';
      }
    } catch (e) {}
    var styleEl = document.createElement('style');
    styleEl.textContent =
      '#jk-bg-upload-modal .jk-bg-upload__title{font-size:1rem;font-weight:700;margin:0 0 .25rem;color:#1A1A1A;}' +
      '#jk-bg-upload-modal .jk-bg-upload__msg{font-size:.85rem;color:#666;margin:0 0 .75rem;line-height:1.4;}' +
      '#jk-bg-upload-modal .jk-bg-upload__spinner{width:24px;height:24px;border:2.5px solid #ECECEC;border-top-color:#FF6B5D;border-radius:50%;animation:jkSpin 1s linear infinite;margin-bottom:.6rem;}' +
      '@keyframes jkSpin{to{transform:rotate(360deg)}}' +
      '#jk-bg-upload-modal .jk-bg-upload__bar{height:3px;background:#F4F4F4;border-radius:2px;overflow:hidden;margin-bottom:.6rem;}' +
      '#jk-bg-upload-modal .jk-bg-upload__bar span{display:block;height:100%;background:linear-gradient(90deg,#FF6B5D,#7B61FF);width:30%;animation:jkBar 1.6s linear infinite;}' +
      '@keyframes jkBar{0%{margin-left:-30%}100%{margin-left:100%}}' +
      '#jk-bg-upload-modal .jk-bg-upload__cta-row{display:flex;gap:.5rem;align-items:stretch;flex-wrap:wrap;}' +
      // #15a: uzun etiket ("İkinci kılıfı tasarla — %25 indirimli") tek satirda tam genislik, "Sepete git" altinda
      '#jk-bg-upload-modal #jk-bg-continue{flex:1 1 100%;min-height:44px;}' +
      '#jk-bg-upload-modal #jk-bg-cart-success{min-height:40px;}' +
      '#jk-bg-upload-modal .jk-bg-upload__close{flex:1;background:#1A1A1A;color:#fff;border:0;padding:.55rem .85rem;border-radius:8px;font-size:.8rem;font-weight:600;cursor:pointer;}' +
      '#jk-bg-upload-modal .jk-bg-upload__close:hover{background:#000}' +
      '#jk-bg-upload-modal .jk-bg-upload__cart-link{flex:1;display:inline-flex;align-items:center;justify-content:center;background:#FF6B2C;color:#fff;text-decoration:none;padding:.55rem .85rem;border-radius:8px;font-size:.8rem;font-weight:700;cursor:pointer;}' +
      '#jk-bg-upload-modal .jk-bg-upload__cart-link:hover{background:#E55A1F}' +
      '#jk-bg-upload-modal .jk-bg-upload__hint{display:block;margin-top:.4rem;font-size:.7rem;color:#999;text-align:center;}' +
      // S27v20 (2026-05-22): success state stili
      '#jk-bg-upload-modal .jk-bg-upload__check{width:32px;height:32px;background:#16895a;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:1.2rem;font-weight:700;margin-bottom:.5rem;}' +
      // C-8: kapatma dugmesi
      '#jk-bg-upload-modal .jk-bg-upload__x{position:absolute;top:6px;right:6px;width:36px;height:36px;border:0;background:transparent;color:#6B6B6B;font-size:22px;line-height:1;cursor:pointer;border-radius:50%;}' +
      '#jk-bg-upload-modal .jk-bg-upload__x:hover{background:#F4F4F4;}';
    document.head.appendChild(styleEl);
    document.body.appendChild(modal);
    // Mesaj rotation
    var msgs = [
      'Yüksek çözünürlükte işleniyor…',
      'UV baskı kalitesinde hazırlanıyor…',
      'Renkleri zenginleştiriyor…',
      'Güvenli bulut depolamaya yükleniyor…',
      'Bağlantı tamamlanıyor, son saniye…',
    ];
    var i = 0;
    var msgEl = modal.querySelector('#jk-bg-msg');
    var msgTimer = setInterval(function () {
      i = (i + 1) % msgs.length;
      if (msgEl) msgEl.textContent = msgs[i];
    }, 3000);
    // Close butonu
    var closeBtn = modal.querySelector('#jk-bg-close');
    var closed = false;
    function close() {
      if (closed) return;
      closed = true;
      clearInterval(msgTimer);
      if (modal.parentNode) modal.parentNode.removeChild(modal);
    }
    closeBtn.addEventListener('click', close);
    // C-8: basari durumunda kapatma (X) — kutu kalici oldugu icin musteri kapatabilmeli
    function addCloseX() {
      if (modal.querySelector('.jk-bg-upload__x')) return;
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'jk-bg-upload__x';
      x.setAttribute('aria-label', 'Kapat');
      x.innerHTML = '&times;';
      x.addEventListener('click', close);
      modal.appendChild(x);
    }

    // S27v20 (2026-05-22): success() upload bitince modal'i kapatma yerine
    // "Sepete Git" CTA persist et. Auto-close YOK; musteri butona basana kadar acik.
    var successed = false;
    function success() {
      if (closed || successed) return;
      successed = true;
      clearInterval(msgTimer);
      modal.innerHTML =
        '<div class="jk-bg-upload__inner">' +
          '<div class="jk-bg-upload__check">&#10003;</div>' +
          '<h3 class="jk-bg-upload__title">Tasarımın yüklendi!</h3>' +
          '<p class="jk-bg-upload__msg">Sepete eklendi — ödeme adımına geçebilirsin.</p>' +
          '<div class="jk-bg-upload__cta-row">' +
            '<button type="button" class="jk-bg-upload__close" id="jk-bg-continue">Yeni tasarım</button>' +
            '<a href="/cart" class="jk-bg-upload__cart-link" id="jk-bg-cart-success">Sepete git →</a>' +
          '</div>' +
        '</div>';
      addCloseX();
      var continueBtn = modal.querySelector('#jk-bg-continue');
      // 2026-09-09: eskiden sadece close() cagriliyordu -> modal kapaniyor ama
      // tasarim ekranda kaliyor, buton hala "Sepete Git" diyordu. Artik tam sifirlama.
      // #15a (2026-10-03): "Yeni tasarım" her seyi (model + kilif tipi dahil) sifirliyor, musteri 4 dokunusla
      // ayni modeli yeniden seciyordu. Artik ilk tasarim sepette kalir, kanvas bosalir, model + kilif tipi KORUNUR
      // (alt cubuk / ust bardaki model dugmesiyle degistirilebilir — iki kisilik siparislerde farkli model var).
      // Sepette tek kilif varsa etiket indirimi soyler. Oran kaynagi: otomatik indirim "İkinci Kılıf %25 İndirim"
      // (BXGY 1 al -> 1 tanesi %25, siparis basina sinirsiz; Admin API 2026-10-03). Indirim degisirse metin elle guncellenmeli.
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          close();
          if (window.JetAtolye && window.JetAtolye.resetAll) window.JetAtolye.resetAll({ keepModel: true });
        });
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
          var n = 0;
          // kilif = model ozellikli ya da model varyantli satir (hazir tasarimlar da BXGY koleksiyonunda)
          ((cart && cart.items) || []).forEach(function (it) {
            if ((it.properties && it.properties['Telefon Modeli']) || (it.variant_title && it.variant_title !== 'Default Title')) n += it.quantity || 0;
          });
          if (n === 1) continueBtn.textContent = 'İkinci kılıfı tasarla — %25 indirimli';
        }).catch(function () {});
      }
    }
    return { close: close, success: success, element: modal };
  }

  // Sayfa kapatma uyarısı (aktif background upload varsa)
  window.addEventListener('beforeunload', function (e) {
    if (_bgUploadActive) {
      e.preventDefault();
      e.returnValue = 'Tasarımın hâlâ yükleniyor. Sayfadan ayrılırsan tasarım kaybolabilir.';
      return e.returnValue;
    }
  });

  // ── Toast notification ────────────────────────────────────
  // Faz C: Notyf delege; Notyf yuklenmemisse eski inline div fallback.
  var _notyfInstance = null;
  function getNotyf() {
    if (_notyfInstance) return _notyfInstance;
    if (typeof Notyf === 'undefined') return null;
    try {
      _notyfInstance = new Notyf({
        duration: 2400,
        position: { x: 'center', y: 'top' },
        types: [
          { type: 'success', background: '#16895a', icon: false },
          { type: 'error', background: '#FF6B5D', icon: false, duration: 3200, dismissible: true },
          { type: 'info', background: '#1A1A1A', icon: false },
          { type: 'warning', background: '#FFD66B', icon: false },
        ],
      });
      return _notyfInstance;
    } catch (e) {
      console.warn('[JetAtolye] Notyf init fail', e);
      return null;
    }
  }
  function notify(msg, kind, opts) {
    kind = kind || 'info';
    var ny = getNotyf();
    if (ny) {
      try { ny.open({ type: kind, message: msg, duration: (opts && opts.duration) || undefined }); return; }
      catch (e) {}
    }
    // Fallback: minimal inline toast (Notyf yoksa)
    var existing = document.getElementById('ja-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'ja-toast';
    t.textContent = msg;
    t.style.cssText = 'position:fixed;top:80px;left:50%;transform:translateX(-50%);background:' +
      (kind === 'error' ? '#FF6B5D' : kind === 'success' ? '#16895a' : '#1A1A1A') +
      ';color:#fff;padding:.75rem 1.5rem;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.2);z-index:10000;font-weight:600;font-size:.85rem;';
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transition = 'opacity .3s'; }, 2200);
    setTimeout(function () { t.remove(); }, 2600);
  }
  // Geriye uyumluluk: showToast eski API olarak kalir, notify'a delege olur
  function showToast(msg, kind) { notify(msg, kind); }

  // v2.8 (kullanici talebi): "Kaydet" / "Indir" sonrasi alt-bant ufak uyari.
  // Notyf YOK (tik/check gostermesin), sadece dusuk-vurgulu metin.
  function showHintBottom(msg) {
    var existing = document.getElementById('ja-hint-bottom');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'ja-hint-bottom';
    t.textContent = msg;
    t.style.cssText = [
      'position:fixed', 'left:50%', 'bottom:20px',
      'transform:translateX(-50%)',
      'background:rgba(26,26,26,0.92)', 'color:#f5f5f0',
      'padding:.55rem 1rem', 'border-radius:6px',
      'font-size:.78rem', 'font-weight:500',
      'letter-spacing:.01em', 'line-height:1.4',
      'max-width:88vw', 'text-align:center',
      'box-shadow:0 4px 12px rgba(0,0,0,.18)',
      'z-index:10000', 'pointer-events:none',
      'opacity:1', 'transition:opacity .3s ease'
    ].join(';');
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; }, 2400);
    setTimeout(function () { if (t.parentNode) t.remove(); }, 2800);
  }

  // ── Inline progress strip (ust sagda 2px) ─────────────────
  // ATC vb. uzun islem sirasinda popup yerine sessiz feedback.
  function startProgress(label) {
    var bar = document.getElementById('ja-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'ja-progress';
      bar.setAttribute('aria-live', 'polite');
      bar.setAttribute('aria-label', label || 'Isleniyor');
      bar.innerHTML = '<div class="ja-progress__fill"></div>';
      bar.style.cssText = 'position:fixed;top:0;left:0;right:0;height:2px;z-index:10001;background:transparent;pointer-events:none;';
      var fill = bar.firstChild;
      fill.style.cssText = 'height:100%;background:linear-gradient(90deg,transparent,#FF6B5D,#7B61FF,transparent);width:30%;animation:ja-progress-slide 1.2s linear infinite;';
      // Animation keyframes (one-time inject)
      if (!document.getElementById('ja-progress-style')) {
        var st = document.createElement('style');
        st.id = 'ja-progress-style';
        st.textContent = '@keyframes ja-progress-slide{0%{transform:translateX(-100%)}100%{transform:translateX(400%)}}';
        document.head.appendChild(st);
      }
      document.body.appendChild(bar);
    }
    bar.style.display = 'block';
  }
  function endProgress() {
    var bar = document.getElementById('ja-progress');
    if (bar) bar.style.display = 'none';
  }

  // ── Inline confirm (native confirm() yerine, non-blocking) ─
  function confirmInline(opts) {
    return new Promise(function (resolve) {
      var ovl = document.createElement('div');
      ovl.className = 'ja-confirm__overlay';
      ovl.style.cssText = 'position:fixed;inset:0;background:rgba(15,18,24,.55);backdrop-filter:blur(4px);z-index:10002;display:flex;align-items:center;justify-content:center;padding:1rem;animation:ja-confirm-fade .15s ease-out;';
      var box = document.createElement('div');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.style.cssText = 'background:#fff;border-radius:14px;padding:1.5rem;max-width:420px;width:100%;box-shadow:0 30px 80px rgba(0,0,0,.25);';
      box.innerHTML = '<h3 style="margin:0 0 .5rem;font-size:1.05rem;font-weight:800">' + (opts.title || 'Emin misin?') +
                      '</h3><p style="margin:0 0 1.25rem;color:#6B6B6B;font-size:.88rem">' + (opts.body || '') +
                      '</p><div style="display:flex;gap:.5rem;justify-content:flex-end">' +
                      '<button type="button" data-act="cancel" style="padding:.55rem 1rem;background:transparent;border:1px solid #E5DFD5;border-radius:8px;cursor:pointer;font-weight:600">' + (opts.cancel || 'Vazgec') + '</button>' +
                      '<button type="button" data-act="ok" style="padding:.55rem 1.2rem;background:#1A1A1A;color:#fff;border:0;border-radius:8px;cursor:pointer;font-weight:700">' + (opts.ok || 'Devam') + '</button>' +
                      '</div>';
      ovl.appendChild(box);
      function done(val) { ovl.remove(); document.removeEventListener('keydown', onKey); resolve(val); }
      // D-10 (2026-09-25): genel "Enter = onay" kaldirildi — odak "Yeniden başla"dayken Enter taslagi
      // geri yukluyordu (ters). Odaktaki buton Enter/Space ile kendi click'ini uretir.
      function onKey(e) {
        if (e.key === 'Escape' && opts.dismissible !== false) done(false);
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-act]');
        if (!b) return;
        done(b.dataset.act === 'ok');
      });
      ovl.addEventListener('click', function (e) {
        if (e.target === ovl && opts.dismissible !== false) done(false);
      });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(ovl);
      try { var okBtn = box.querySelector('button[data-act="ok"]'); if (okBtn) okBtn.focus(); } catch (e) {}
      // Inject keyframes once
      if (!document.getElementById('ja-confirm-style')) {
        var st = document.createElement('style');
        st.id = 'ja-confirm-style';
        st.textContent = '@keyframes ja-confirm-fade{from{opacity:0}to{opacity:1}}';
        document.head.appendChild(st);
      }
    });
  }

  // ── 2-katman manifest yükleme (lazy fetch) ───────────────────
  var _pairsLoading = null;
  function loadFramePairs() {
    if (window.JET_FRAME_PAIRS) return Promise.resolve(window.JET_FRAME_PAIRS);
    if (_pairsLoading) return _pairsLoading;
    var url = window.JET_FRAME_PAIRS_URL;
    if (!url) {
      window.JET_FRAME_PAIRS = {};
      return Promise.resolve({});
    }
    _pairsLoading = fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (m) { window.JET_FRAME_PAIRS = m; return m; })
      .catch(function (e) {
        // Faz 3.2: silent fallback yasak — modal goster + canvasBlocked
        // D-08 (2026-09-25): eskiden bos manifest ({}) KALICI yaziliyordu -> "Başka model seç" sonrasi her model
        // jenerik dikdortgen kesimle aciliyor ve Sepete Ekle aktif oluyordu (yanlis sekilli baski riski).
        // Artik manifest bos birakilmaz; sonraki model seciminde yeniden denenir.
        console.error('[JetAtolye] frame pairs fetch fail', e);
        _pairsLoading = null;
        showFatalFrameModal('Frame manifesti yuklenemedi: ' + (e && e.message || e));
        return null;
      });
    return _pairsLoading;
  }

  // ── Frame overlay (telefon back) — 2-katman v2 ───────────────
  // Layer 01 = baskının geleceği alan → canvas.backgroundImage (canvas içinde, alt katman)
  // Layer 02 = görünecek kasa kısmı (bezel + camera ring) → <img id="ja-frame-overlay"> üst overlay
  // ClipPath = (01.alpha ∩ ~02.alpha) → manifest'ten okunan SVG path (Fabric.Path).
  // Fallback: pair veya clip_path manifest'te yoksa eski rounded-rect davranışı.
  function applyFrame(slugOrName, brand) {
    if (!window.JET_FRAME_PAIRS) {
      // D-08: manifest inmediyse sonsuz dongu yok; basarisizsa modal zaten gosterildi, kesim uygulanmaz
      loadFramePairs().then(function (m) { if (m) applyFrame(slugOrName, brand); });
      return;
    }
    var imgTop = document.getElementById('ja-frame-overlay');
    var slug = slugOrName || '';
    if (window.JET_FRAME && (slug.indexOf('-') < 0 || /[A-Z\s]/.test(slug))) {
      slug = window.JET_FRAME.toSlug(brand || state.modelBrand || '', slugOrName || '');
    }

    var pairs = window.JET_FRAME_PAIRS || {};
    var pair = pairs[slug];
    var url01 = pair && pair.url_01;
    var url02 = pair && pair.url_02;
    var clipPathStr = pair && pair.clip_path;
    // D-08: secili modelin kesimi yoksa jenerik dikdortgenle SATISA izin verme (yanlis sekilli baski riski)
    if (slug && !clipPathStr) {
      showFatalFrameModal('Bu model icin kesim bulunamadi: ' + slug);
    } else if (clipPathStr && state.canvasBlocked && !document.getElementById('ja-frame-fatal-title')) {
      // onceki hata gecti (manifest yeniden indi, modal kapali) -> kilit kalksin
      state.canvasBlocked = false;
    }

    // --- Layer 02: üst overlay (bezel) ---
    if (imgTop) {
      if (url02) {
        imgTop.src = url02;
      } else if (window.JET_FRAME && window.JET_FRAME.getFrameUrl) {
        // Geriye dönük: v1 single-frame URL
        var legacy = window.JET_FRAME.getFrameUrl(slug)
          || (window.JET_DEVICE_PHOTOS && window.JET_DEVICE_PHOTOS[slug]);
        if (legacy) imgTop.src = legacy;
        else imgTop.removeAttribute('src');
      } else {
        imgTop.removeAttribute('src');
      }
    }

    if (!canvas) return;

    // --- ClipPath: per-model irregular path (camera cutout dahil) ---
    if (clipPathStr) {
      try {
        canvas.clipPath = new fabric.Path(clipPathStr, {
          absolutePositioned: true,
          fillRule: 'evenodd',
          selectable: false,
          evented: false,
        });
      } catch (e) {
        // Faz 3.2: silent fallback yasak — kullanici yanlis frame'le tasarim yapmasin
        console.error('[applyFrame] clipPath parse fail', e);
        showFatalFrameModal('ClipPath parse hatasi: ' + (e && e.message || e));
        // Yine de canvas.clipPath set edilmeli ki render bozulmasin (kullanici reload yapacak)
        canvas.clipPath = new fabric.Rect({
          left: PRINT.x, top: PRINT.y, width: PRINT.w, height: PRINT.h,
          rx: PRINT.r, ry: PRINT.r, absolutePositioned: true,
        });
      }
    } else {
      canvas.clipPath = new fabric.Rect({
        left: PRINT.x, top: PRINT.y, width: PRINT.w, height: PRINT.h,
        rx: PRINT.r, ry: PRINT.r, absolutePositioned: true,
      });
    }

    // 01 layer SADECE clipPath maskesi olarak kullanılır (gorsel render YOK).
    // 01 PNG'i koyu gri telefon sekli — body olarak gozukmemeli.
    // Canvas backgroundColor transparent → .ja-canvas__device div #fff govde rengi olarak gozukur.
    // 02 (us catman, kamera + bezel) <img id="ja-frame-overlay"> ile render edilir.
    // url01 hala manifest'te kalir (export/ATC pipeline icin).
    if (canvas.backgroundImage) {
      canvas.setBackgroundImage(null, canvas.renderAll.bind(canvas));
    }

    // v2.8.3: Fabric.js IText canvas-level clipPath'i bypass edebiliyor (bilinen
    // edge case — drag/resize sirasinda text frame disinda gorunur kaliyor).
    // Cozum: her objeye kendi clipPath klonunu ata (absolutePositioned).
    refreshObjectClipPaths();
  }

  // D-03 (2026-09-25): tasarim araci (fabric) hic yuklenemezse gorunur mesaj + yenile.
  function showFabricFail() {
    if (document.getElementById('ja-fabric-fail')) return;
    var box = document.createElement('div');
    box.id = 'ja-fabric-fail';
    box.setAttribute('role', 'alert');
    box.style.cssText = 'position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);z-index:10003;background:#fff;'
      + 'border-radius:14px;padding:20px 22px;max-width:360px;width:calc(100% - 32px);box-shadow:0 20px 60px rgba(0,0,0,.25);'
      + 'font-family:inherit;text-align:center;color:#1A1A1A';
    box.innerHTML = '<p style="margin:0 0 6px;font-size:16px;font-weight:700">Tasarım aracı yüklenemedi</p>'
      + '<p style="margin:0 0 14px;font-size:14px;line-height:1.45;color:#4A4A4A">Bağlantını kontrol edip sayfayı yenile. Sorun sürerse WhatsApp\'tan yaz, yardımcı olalım.</p>'
      + '<button type="button" style="background:#1A1A1A;color:#fff;border:0;border-radius:8px;padding:11px 18px;font-size:14px;font-weight:700;cursor:pointer">Sayfayı yenile</button>';
    box.querySelector('button').addEventListener('click', function () { location.reload(); });
    (document.body || document.documentElement).appendChild(box);
  }

  // Tum objelere mevcut canvas.clipPath klonunu ata. BG layer ve collage slot
  // muafiyetli (bunlar zaten clipPath'siz). object:added event'inde de cagrilir.
  function refreshObjectClipPaths() {
    if (!canvas || !canvas.clipPath) return;
    var src = canvas.clipPath;
    canvas.getObjects().forEach(function (obj) {
      assignObjectClipPath(obj);
    });
    canvas.requestRenderAll();
  }

  // B-03 (2026-09-25): loadFromJSON (Geri al / Ileri al / taslak / slot) kayittaki canvas + nesne
  // clipPath'lerini de geri yukluyor -> model degistikten sonra Geri al eski modelin kesimini getiriyordu
  // (S22 Ultra secili, iPhone 15 kesimiyle baski). Her geri yuklemeden sonra secili modelin kesimi uygulanir.
  function reapplyCurrentClip() {
    if (!canvas) return;
    if (state.modelSlug) { applyFrame(state.modelSlug, state.modelBrand); return; }
    canvas.clipPath = new fabric.Rect({
      left: PRINT.x, top: PRINT.y, width: PRINT.w, height: PRINT.h,
      rx: PRINT.r, ry: PRINT.r, absolutePositioned: true,
    });
    refreshObjectClipPaths();
  }

  function assignObjectClipPath(obj) {
    if (!obj || !canvas || !canvas.clipPath) return;
    // Sablon v2: yuva fotosu (jkSlotIndex) kendi yuva kesimini tasir; model kesimi onu ezmesin (01 rapor §3.4-1)
    if (obj.name === '__jk_bg_layer' || obj.isCollageSlot || obj.jkSlotIndex != null) return;
    canvas.clipPath.clone(function (cloned) {
      cloned.absolutePositioned = true;
      obj.set('clipPath', cloned);
      obj.dirty = true;
      canvas.requestRenderAll();
    });
  }

  // ── Model gating helpers (Faz A) ──────────────────────────
  // Sepete Ekle butonunu mevcut model durumuna gore acar/kapar.
  // Tooltip ve aria-disabled da senkron tutulur.
  function setAtcEnabled(enabled) {
    // Faz 1.1: ATC hem model hem productKey confirmed olunca aktif
    var canAtc = !!(enabled && state.productKeyConfirmed);
    var btns = document.querySelectorAll('[data-action="add-to-cart"]');
    btns.forEach(function (btn) {
      if (canAtc) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('title');
      } else {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        if (!state.modelConfirmed) {
          btn.setAttribute('title', 'Once telefon modeli sec');
        } else {
          btn.setAttribute('title', 'Lutfen kilif tipini secin');
        }
      }
    });
  }

  // Resmi model secimi - modal "Onayla" tiklandiginda cagrilir.
  // Default boot vs onaylanmis secimi modelConfirmed flag ile ayirir.
  function setModel(brand, modelName, opts) {
    opts = opts || {};
    var slug = (window.JET_FRAME && window.JET_FRAME.toSlug(brand, modelName)) || modelName;
    state.modelBrand = brand || null;
    state.model = modelName || null;
    state.modelSlug = slug;
    state.modelConfirmed = opts.confirmed !== false;  // default true
    applyFrame(slug, brand);
    var lbl = document.getElementById('ja-model-label');
    if (lbl) lbl.textContent = modelName || 'Telefon Modeli Sec';
    setAtcEnabled(state.modelConfirmed);
    bus.emit('model-change', { brand: brand, model: modelName, slug: slug, confirmed: state.modelConfirmed });
    autoSave();

    // v2.3: applyFrame sonrası mevcut objeleri sadece canvas-bounds'a clamp et
    // (kullanıcı tercihi: kullanıcı pozisyonu yerinde kalsın, sadece canvas içi).
    setTimeout(function () {
      if (!canvas) return;
      canvas.getObjects().forEach(function (obj) {
        if (!obj || obj.name === '__jk_bg_layer' || obj.isCollageSlot) return;
        try { clampToPa(obj); } catch (e) { /* ignore */ }
      });
      canvas.requestRenderAll();
    }, 200);
  }

  // Faz 3.2: Frame load/parse fail'lerinde sessiz fallback yasak.
  // Modal goster + state.canvasBlocked + setAtcEnabled(false). Idempotent (tek sefer acilir).
  function showFatalFrameModal(detail) {
    if (state.canvasBlocked) return;
    state.canvasBlocked = true;
    setAtcEnabled(false);
    bus.emit('canvas-blocked', { detail: detail });

    // CSS class wizard.js (jw-resume-modal-*) ile paylasilir. Wizard yuklenmemisse inline style.
    if (!document.getElementById('jw-resume-modal-style') && !document.getElementById('ja-frame-modal-style')) {
      var st = document.createElement('style');
      st.id = 'ja-frame-modal-style';
      st.textContent = '\
.jw-resume-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;font-family:inherit}\
.jw-resume-modal__backdrop{position:absolute;inset:0;background:rgba(26,26,26,.55)}\
.jw-resume-modal__panel{position:relative;background:#FAF5EE;border-radius:16px;padding:1.75rem 1.5rem;max-width:380px;width:calc(100% - 2rem);box-shadow:0 8px 32px rgba(0,0,0,.18)}\
.jw-resume-modal__title{font-size:1.15rem;font-weight:700;color:#1A1A1A;margin:0 0 .65rem}\
.jw-resume-modal__body{font-size:.92rem;line-height:1.5;color:#4A4A4A;margin:0 0 1.25rem}\
.jw-resume-modal__actions{display:flex;gap:.6rem;justify-content:flex-end;flex-wrap:wrap}\
.jw-resume-modal__btn{font-size:.88rem;font-weight:600;padding:.65rem 1.1rem;border-radius:10px;cursor:pointer;border:none;font-family:inherit}\
.jw-resume-modal__btn--primary{background:#FF6B5D;color:#fff}\
.jw-resume-modal__btn--ghost{background:transparent;color:#4A4A4A;border:1px solid rgba(0,0,0,.15)}';
      document.head.appendChild(st);
    }

    var modal = document.createElement('div');
    modal.className = 'jw-resume-modal';
    modal.setAttribute('role', 'alertdialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'ja-frame-fatal-title');
    var detailHtml = detail ? '<br/><small style="opacity:.6">' + String(detail).replace(/[<>]/g, '').slice(0, 120) + '</small>' : '';
    modal.innerHTML = '<div class="jw-resume-modal__backdrop"></div>'
      + '<div class="jw-resume-modal__panel">'
      + '  <h2 class="jw-resume-modal__title" id="ja-frame-fatal-title">Frame yuklenemedi</h2>'
      + '  <p class="jw-resume-modal__body">Bu modelin tasarim cercevesi yuklenemedi. Sayfayi yenilemeyi veya farkli bir model secmeyi deneyin.' + detailHtml + '</p>'
      + '  <div class="jw-resume-modal__actions">'
      + '    <button type="button" class="jw-resume-modal__btn jw-resume-modal__btn--ghost" data-action="model">Baska model sec</button>'
      + '    <button type="button" class="jw-resume-modal__btn jw-resume-modal__btn--primary" data-action="reload" autofocus>Sayfayi yenile</button>'
      + '  </div>'
      + '</div>';
    modal.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.dataset && t.dataset.action === 'reload') {
        location.reload();
      } else if (t && t.dataset && t.dataset.action === 'model') {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
        state.canvasBlocked = false; // model modal acilsin diye unblock
        if (window.JetModelModal && window.JetModelModal.open) {
          window.JetModelModal.open({ forceFirst: true });
        }
      }
    });
    document.body.appendChild(modal);
  }

  // Default boot: querystring > draft > YOK (Faz I-6: default model fallback kaldırıldı).
  // Faz I-6: Hazır tasarım sayfasından gelirken default iPhone 16 Pro frame'i kullanıcıyı yanıltıyordu.
  // Şimdi: querystring ?model=<slug> varsa onu kullan, draft varsa onu restore et, hiçbiri yoksa
  // canvas BLANK kalır + state.model='' + ATC disabled. Kullanıcı Step 1'de model seçmek zorunda.
  var _urlModelFound = false;
  function bootDefaultModel() {
    var qs = new URLSearchParams(window.location.search);
    var qSlugRaw = qs.get('model');
    // A3 (2026-09-25): ?model=IPHONE-15 gibi buyuk harfli gelis de taninsin
    var qSlug = qSlugRaw ? String(qSlugRaw).toLowerCase().trim() : '';
    // S17 A5: PDP'den gelen productKey URL param (alias: caseType) — Step 2 bypass
    var qPK = qs.get('productKey') || qs.get('caseType');
    if (qPK === 'tpu' || qPK === 'magsafe') {
      try { setProductKey(qPK, { confirmed: true }); } catch (e) { /* ignore */ }
    } else {
      // A7 (2026-09-25): URL'de yoksa taslaktaki onayli kilif tipi geri gelir (kart atolyede varsa — MagSafe kapaliyken gelmez)
      var dPK = _bootDraft || loadDraft();
      if (dPK && dPK.productKeyConfirmed && (dPK.productKey === 'tpu'
          || (dPK.productKey === 'magsafe' && document.querySelector('.jw__product-card[data-product-key="magsafe"]')))) {
        try { setProductKey(dPK.productKey, { confirmed: true }); } catch (e) { /* ignore */ }
      }
    }
    if (qSlug && window.JET_FRAME) {
      var found = window.JET_FRAME.findBySlug(qSlug);
      if (found) { _urlModelFound = true; setModel(found.brand, found.name, { confirmed: true }); return; }
      // A3: taninmayan ?model= -> taslaktaki modele SESSIZCE ve onayli dusme (eskiden Galaxy S23 vb.
      // secili geliyordu). Model bos kalir, musteri listeden secer.
      setTimeout(function () {
        notify('Bağlantıdaki telefon modeli tanınmadı — lütfen modelini listeden seç.', 'warning', { duration: 6000 });
      }, 900);
      return;
    }
    // D-09 (2026-09-25): ?from=direct icin ayri (wizard) taslak diyalogu kaldirildi; tek diyalog init()'te.
    var draft = _bootDraft || loadDraft();
    if (_validDraftModel(draft)) {
      setModel(draft.modelBrand, draft.model, { confirmed: !!draft.modelConfirmed });
      return;
    }
    // Faz I-6: Default model fallback KALDIRILDI — canvas blank, kullanıcı Step 1'de model seçer
  }

  // Faz 1.3: Wizard modal "Devam et" cevabinda manuel draft restore.
  // Returns true if draft restored, false if no draft.
  function restoreDraft() {
    var draft = loadDraft();
    if (!_validDraftModel(draft)) return false;
    _resumeDraft(draft, true);
    return true;
  }

  // ── 2026-09-25: tek taslak diyalogu (B-05, A3, A4, D-09, D-10) ─────────────
  // Karar verilene kadar state._draftPending=true -> autoSave taslagin uzerine yazmaz.
  // Wizard ?template= yuklemesini JetAtolye.draftDecision'i bekleyerek yapar ('resume' ise yuklemez).
  var _draftDecisionResolve = null;
  var draftDecision = new Promise(function (res) { _draftDecisionResolve = res; });
  function _resolveDraftDecision(v) {
    if (_draftDecisionResolve) { _draftDecisionResolve(v); _draftDecisionResolve = null; }
  }
  function _draftHasContent(d) {
    return !!(d && d.fabric && d.fabric.objects && d.fabric.objects.length);
  }
  // Taslaktaki model atolye listesinde mi? (A2 hatasindan kalma "— Model seç —" gibi kayitlar kurulmaz)
  function _validDraftModel(d) {
    if (!d || !d.model || !d.modelBrand) return false;
    if (!window.JET_FRAME || !window.JET_FRAME.findBySlug) return true;
    return !!window.JET_FRAME.findBySlug(window.JET_FRAME.toSlug(d.modelBrand, d.model));
  }
  function _esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function _fmtAgo(ts) {
    var diff = Math.max(0, (Date.now() - (ts || 0)) / 1000);
    if (!ts) return '';
    if (diff < 60) return 'Az önce';
    if (diff < 3600) return Math.floor(diff / 60) + ' dakika önce';
    if (diff < 86400) return Math.floor(diff / 3600) + ' saat önce';
    if (diff < 86400 * 7) return Math.floor(diff / 86400) + ' gün önce';
    try { return new Date(ts).toLocaleDateString('tr-TR') + ' tarihinde'; } catch (e) { return ''; }
  }
  // C3-M3: bayat taslakta model yok/yer tutucu ("— Model seç —") ise parantezli model adi gosterilmez
  function _draftModelLabel(d) {
    return !!(d && d.model && !/^\s*[—–-]/.test(d.model) && _validDraftModel(d));
  }
  function _askResume(draft, qTemplate) {
    setTimeout(function () {
      var ago = _fmtAgo(draft.ts);
      var body = (ago ? _esc(ago) + ' ' : '') + 'başladığın bir tasarımın var'
        + (_draftModelLabel(draft) ? ' (<strong>' + _esc(draft.model) + '</strong>)' : '') + '.';
      var opts = { title: 'Kaldığın yerden devam?', ok: 'Önceki tasarımım', cancel: 'Yeni tasarım', dismissible: false };
      if (qTemplate) {
        body += ' Seçtiğin hazır tasarımla mı başlayalım, önceki tasarımınla mı devam edelim?';
        opts.cancel = 'Seçtiğim hazır tasarım';
      }
      opts.body = body;
      confirmInline(opts).then(function (yes) {
        if (yes) _resumeDraft(draft, false);
        else _discardDraft();
      });
    }, 400);
  }
  function _resumeDraft(draft, keepModelFromDraft) {
    // URL'de taninan model varsa o kalir (musterinin son secimi; A3), yoksa taslagin modeli.
    if ((keepModelFromDraft || !_urlModelFound) && _validDraftModel(draft)) {
      if (draft.model !== state.model || !state.modelConfirmed) {
        setModel(draft.modelBrand, draft.model, { confirmed: !!draft.modelConfirmed });
      }
    } else if (draft.model && state.model && draft.model !== state.model) {
      var dm = draft.model, cm = state.model;
      setTimeout(function () {
        notify('Önceki tasarımın ' + _esc(dm) + ' içindi; şimdi ' + _esc(cm) + ' kılıfına yerleştirildi.', 'info', { duration: 6000 });
      }, 400);
    }
    state.template = draft.template || null;   // A4: siparisteki sablon adi basilacak tasarimla ayni
    if (!draft.fabric || !canvas) {
      state._draftPending = false;
      _resolveDraftDecision('resume');
      return;
    }
    _hydrateDraftPhotos(draft.fabric).then(function (res) {
      undoMuted = true;
      try {
        canvas.loadFromJSON(res.json, function () {
          reapplyCurrentClip();   // B-03: taslaktaki (eski) kesim degil, secili modelinki
          canvas.requestRenderAll();
          undoMuted = false;
          undoStack.length = 0; redoStack.length = 0;
          pushUndoSnapshot();
          state._draftPending = false;
          _resolveDraftDecision('resume');
          autoSave();
          if (res.missing) {
            notify(res.missing + ' fotoğraf bu cihazda bulunamadı — lütfen yeniden yükle.', 'warning', { duration: 7000 });
          }
          bus.emit('draft-restored', draft);
        });
      } catch (e) {
        undoMuted = false;
        state._draftPending = false;
        _resolveDraftDecision('resume');
        console.warn('[JetAtolye] taslak yuklenemedi', e);
      }
    });
  }
  function _discardDraft() {
    try { localStorage.removeItem('jetkilif:atolye_draft'); } catch (e) {}
    _photoClear();
    state._draftPending = false;
    _resolveDraftDecision('fresh');
    autoSave();
    bus.emit('draft-cleared');
  }

  // Faz 1.3: Yeni tasarim (draft sil + canvas/state reset).
  function clearDraft() {
    try { localStorage.removeItem('jetkilif:atolye_draft'); } catch (e) {}
    _photoClear();
    if (canvas) {
      try {
        canvas.getObjects().slice().forEach(function (o) {
          if (o && o.name !== '__jk_bg_layer') canvas.remove(o);
        });
        canvas.requestRenderAll();
      } catch (e) {}
    }
    state.template = null;
    bus.emit('draft-cleared');
  }

  // 2026-09-09: "Yeni tasarim" tam sifirlama.
  // clearDraft() sadece tasarim ogelerini siliyordu; arka plan katmani, model ve
  // kilif tipi kaliyordu -> musteri "Yeni tasarim"a basinca hicbir sey degismiyordu.
  // #15a (2026-10-03): resetAll({ keepModel: true }) = "ikinci kilif": tasarim + bayraklar sifirlanir, secili model ve
  // kilif tipi KORUNUR, model penceresi acilmaz, Fotograf adimi acilir. Sepetteki ilk tasarima dokunulmaz.
  function resetAll(opts) {
    opts = opts || {};
    if (_bgUploadActive) return;   // yarim upload varken sifirlama YOK (siparis property'leri bozulur)
    if (opts.keepModel && state.model && state.modelConfirmed) return _resetDesignKeepModel();
    clearDraft();
    if (canvas) {
      try {
        canvas.getObjects().slice().forEach(function (o) { canvas.remove(o); });
        canvas.requestRenderAll();
      } catch (e) {}
    }
    state.template = null;
    state.photoBlobs = {};
    state.lastPreviewUrl = null;
    state.historyStack = [];
    state.historyIndex = -1;
    state.modelConfirmed = false;
    state.productKeyConfirmed = false;
    state.productKey = null;
    // C-7 (2026-09-25): masaustu ust barda eski model adi kaliyordu
    var mLbl = document.getElementById('ja-model-label');
    if (mLbl) mLbl.textContent = 'Telefon Modeli Seç';
    // sections/jet-atolye-shell.liquid "Hemen Satin Al" yolu bu iki global bayragi
    // OKUYOR (bkz. bu dosyada 1485-1486, 1527-1528). Sifirlanmazsa ikinci tasarimda
    // buyNow, tasarimi sepete hic eklemeden dogrudan /checkout'a atliyor.
    window.__jet_uploadComplete = false;
    window.__jet_uploadInProgress = false;
    _uploadedSig = null;
    setAtcEnabled(false);
    try { localStorage.removeItem('jetkilif:atolye_draft'); } catch (e) {}
    try { localStorage.removeItem('jetkilif:atolye_pending_upload'); } catch (e) {}
    bus.emit('atolye-reset');
    document.dispatchEvent(new CustomEvent('jet:atolye-reset'));
    if (window.JetModelModal && window.JetModelModal.open) {
      window.JetModelModal.open({ forceFirst: true });
    }
  }
  function _resetDesignKeepModel() {
    try { localStorage.removeItem('jetkilif:atolye_draft'); } catch (e) {}
    _photoClear();
    if (canvas) {
      try {
        canvas.discardActiveObject();
        undoMuted = true;
        // safe-zone kilavuzu kanvasin parcasi (initCanvas'ta 1 kez eklenir) — tasarim degil, kalir
        canvas.getObjects().slice().forEach(function (o) { if (o && o.name !== '__jk_safezone_guide') canvas.remove(o); });
        undoMuted = false;
        canvas.requestRenderAll();
      } catch (e) { undoMuted = false; }
    }
    bus.emit('draft-cleared');
    state.template = null;
    state.photoBlobs = {};
    state.lastPreviewUrl = null;
    state.historyStack = [];
    state.historyIndex = -1;
    // bkz. resetAll: "Hemen Satin Al" bu bayraklari okuyor — sifirlanmazsa yeni tasarim sepete eklenmeden checkout'a gider
    window.__jet_uploadComplete = false;
    window.__jet_uploadInProgress = false;
    _uploadedSig = null;
    try { localStorage.removeItem('jetkilif:atolye_pending_upload'); } catch (e) {}
    undoMuted = true;
    undoStack.length = 0; redoStack.length = 0;
    undoMuted = false;
    pushUndoSnapshot();   // bos kanvas = yeni tasarimin Geri al tabani (ilk tasarima geri donulmez)
    autoSave();           // taslak: model + kilif tipi, bos tasarim
    // bus 'atolye-reset' YAYINLANMAZ: wizard dinleyicisi alt cubuktaki model etiketini 'Model'e cevirir (model korunuyor)
    document.dispatchEvent(new CustomEvent('jet:atolye-reset', { detail: { keepModel: true } }));
    // Eski shell dinleyicisi (detail'i bilmeyen) ATC'yi kapatir — model + tip secili oldugu icin yeniden ac
    setAtcEnabled(state.modelConfirmed);
    var name = state.model || '';
    notify('Yeni tasarım: ' + _esc(name) + '. Başka telefon için modeli değiştirebilirsin.', 'info', { duration: 5000 });
  }

  // Faz 1.1: Wizard productKey secimi -> core.js state bridge + ATC reactive enable
  // Wizard.js click handler'i bu API'yi confirmed:true ile cagrir.
  // Default boot/fallback durumlarinda CONFIRMED set edilmez (ATC kapali kalsin).
  function setProductKey(key, opts) {
    opts = opts || {};
    state.productKey = key || null;
    if (opts.handle) state.productHandle = opts.handle;
    state.productKeyConfirmed = opts.confirmed !== false;
    setAtcEnabled(state.modelConfirmed); // setAtcEnabled icinde productKeyConfirmed AND'lenir
    bus.emit('product-change', { key: key, handle: opts.handle, confirmed: state.productKeyConfirmed });
  }

  // ── Init ──────────────────────────────────────────────────
  var _bootDraft = null;
  function init() {
    // B-05: taslak, hicbir sey (safe-zone kilavuzu, setModel, sablon) autoSave tetiklemeden ONCE okunur;
    // icerikli taslak varsa karar verilene kadar uzerine yazilmaz.
    _bootDraft = loadDraft();
    if (_draftHasContent(_bootDraft)) state._draftPending = true;
    var c = initCanvas();
    if (!c) { state._draftPending = false; _resolveDraftDecision('none'); return; }
    setupFloatingToolbar();
    setupPhotoInput();
    setupRailPanels();
    setupShellActions();
    initGestures(); // G.4 — pinch-zoom + rotate (mobile-only, Hammer.js)
    initUndoButton(); // G.6 — undo
    pushUndoSnapshot(); // baseline boş canvas snapshot
    _setupBgPreviewListener(); // Faz 4.5: bg preview pre-upload (debounce 2s)

    // Stok manifest yukle (asenkron - default boot blocking degil)
    if (window.JET_FRAME && window.JET_FRAME.loadStockManifest) {
      // asset_url prefix runtime'da bilmeden, /assets/ varsayar; Shopify CDN ile de calisir
      var prefix = '';
      var s = document.querySelector('script[src*="jet-frame-urls.js"]');
      if (s) prefix = s.src.replace(/jet-frame-urls\.js.*$/, '');
      window.JET_FRAME.loadStockManifest(prefix);
    }

    // Default model boot - querystring > draft > iPhone 16 Pro fallback
    bootDefaultModel();

    // Query string deep-link (?template=x) — sablonun kendisini wizard, taslak karari verilince yukler
    var qs = new URLSearchParams(window.location.search);
    var qTemplate = qs.get('template');
    if (qTemplate) {
      state.template = qTemplate;
      bus.emit('load-template', qTemplate);
    }

    // Restore draft fabric (model bilgileri bootDefaultModel'de yuklenir) — tek diyalog (A4, B-05, D-09)
    if (_draftHasContent(_bootDraft)) {
      _askResume(_bootDraft, qTemplate);
    } else {
      _resolveDraftDecision('none');
    }
    // B9 (2026-09-24): olu 'add-object' dinleyicisi kaldirildi (emit eden yok).
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.JetAtolye = {
    _initialized: true,
    bus: bus,
    state: state,
    PRINT: PRINT,
    getPrintBounds: getPrintBounds,
    CANVAS_W: CANVAS_W,
    CANVAS_H: CANVAS_H,
    canvas: function () { return canvas; },
    showToast: showToast,
    notify: notify,
    confirmInline: confirmInline,
    startProgress: startProgress,
    endProgress: endProgress,
    applyFrame: applyFrame,
    reapplyClip: reapplyCurrentClip,       // 2026-09-25 B-03 (slot/sablon yuklemeleri icin)
    draftDecision: draftDecision,          // 2026-09-25: 'resume' | 'fresh' | 'none'
    setModel: setModel,
    setProductKey: setProductKey,  // Faz 1.1
    setAtcEnabled: setAtcEnabled,
    bootDefaultModel: bootDefaultModel,
    restoreDraft: restoreDraft,    // Faz 1.3
    clearDraft: clearDraft,        // Faz 1.3
    resetAll: resetAll,            // 2026-09-09: tam sifirlama (canvas+model+kilif tipi+bayraklar)
    loadDraft: loadDraft,          // Faz 1.3 (read-only, modal timestamp icin)
    exportPreviewBlob: exportPreviewBlob,  // Faz 4.3 (WebP/JPEG preview blob)
    uploadPreview: uploadPreview,          // Faz 4.3 (POST /upload/preview)
    exportPrint: exportPrint,              // Faz 4.4 (print PNG 2000x4000, frame overlay yok)
    undoBatch: undoBatch,                  // Sablon v2 (2026-10-03): cok nesneli kurulum = tek Geri al adimi
    _exportForR2: exportForR2,             // Sablon v2: yalniz QA/dogrulayici (sepete eklemeden baski dosyasi)
    _undoBytes: function () { var n = 0; undoStack.concat(redoStack).forEach(function (x) { n += x.length; }); Object.keys(_undoPool).forEach(function (k) { n += _undoPool[k].length; }); return { stack: undoStack.length, redo: redoStack.length, bytes: n, pool: Object.keys(_undoPool).length }; }, // C10 teshis
    openModelModal: function (opts) {
      if (window.JetModelModal && window.JetModelModal.open) {
        window.JetModelModal.open(opts || {});
      }
    },
  };
})();
